import React from "react";

export const instantCriminalContent = (
  <div id="coverageContent" className={"instant-criminal-coverage"}>
    <p className="coverage-title">
      LocatePLUS Instant Criminal Record Check Coverage
    </p>
    <p className="long-line">
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Alabama</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
    </p>
    <p className="coverage-content-sub-title">
      <br />
      Alabama Dept of Corrections
    </p>
    <p>
      Corrections records of statewide records of currently incarcerated
      inmates. Records on approximately 25,000 persons. Results may show
      defendant name, DOB, race, sex, release date, offense description, status,
      and current location. Available instantly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Alabama Sex Offender</p>
    <p>
      Alabama Sex Offender Registry contains information about individuals found
      to have committed a sex offense under Alabama Law. Data includes offender
      photos. Monthly updates.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from AL, which contained records.
    </p>
    <p className="long-line">
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Alaska</p>
    <p className="long-line">
      <br />
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Alaska Admin Office of Courts</p>
    <p>
      This database contains current and historical felony and misdemeanor
      records of individuals who are or have been under the jurisdiction of the
      Alaska Court system. Quarterly updates of the most current data available
      are provided.
      <br />
    </p>
    <p className="coverage-content-sub-title">Alaska Sex Offender</p>
    <p>
      Alaska Sex Offender Registry records. Data includes name, address,
      photograph, place of employment, date of birth, crime for which convicted,
      date of conviction and place and court of conviction. Updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from AK, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Arkansas</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Arkansas Admin Office of Courts
    </p>
    <p>
      Court records of statewide felony and state-level misdemeanor dispositions
      since 1987. Records on approximately 400,000 persons. These records
      contain information submitted to the state by courts from each county and
      other criminal justice agencies. Results may include the disposition date,
      arrest date, county, case #, defendant name, DOB, race, sex, charge(s),
      dispositions and sentence. Records updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Arkansas Dept Corrections</p>
    <p>
      Corrections records of statewide felony criminal convictions on persons
      who have been sentenced to serve time at a state facility since 1940.
      Records on approximately 20,000 persons. Results show the date of crime,
      county, defendant name, DOB, race, sex, height, weight, charge(s), and
      sentence.
      <br />
    </p>
    <p className="coverage-content-sub-title">Arkansas Sex Offender</p>
    <p>
      Registry contains information on individuals considered to be at the
      highest level of risk (Level 3 - High Risk and Level 4 - Sexually Violent
      Predator) to the public. Data may contain name, DOB, address, offense, and
      level of risk. Photos included.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from AR, which contained records.
      <br />
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Arizona</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Arizona Courts</p>
    <p>
      Court records of statewide felony and misdemeanor dispositions from all
      counties except Pima and Maricopa since 1987. Records on over 5,600,000
      persons. Results may include the file date, disposition date, county, case
      number, defendant name, DOB, race, sex, charge(s), dispositions and
      sentence. Records updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Arizona Dept of Corrections</p>
    <p>
      Corrections records of statewide felony criminal convictions and guilty
      pleas on persons who have been sentenced to serve time at a state facility
      since 1985. Records on approximately 122,000 persons. Results may include
      the date of crime, county, case number, defendant name, DOB, race, sex,
      height, weight, FBI number, charge(s), and sentence. Records updated
      monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Arizona Sex Offender</p>
    <p>
      Data is only provided for sex offenders released from jail/prison or
      sentenced to probation on or after June 1,1996 with risk assessment scores
      of Level 2 (Intermediate) or Level 3 (High). Data includes over 1000 Sex
      Offender photographs. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Pima County</p>
    <p>
      Data provided by the Pima County Supreme Court. Contains conviction
      records dating back to 1994. Data may include offense, disposition date,
      file date, and degree of offense.
    </p>
    <p>
      Cities in this county are: Why, Sells, Topawa, Vail, Pisinemo, Rillito,
      Sasabe, Green Valley, Lukeville, Mount Lemmon, Corona de Tucson, Cortaro,
      Davis Monthan Air Force Base, Arivaca, Catalina, Corona, South Tucson,
      Tucson, Ajo, Marana, Oro Valley and Sahuarita.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from AZ, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">California</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
      <br />
      *** The majority of records in the California data do not contain Date of
      Births or the description of the Offenses. If you do run the California
      instant search and receive a hit from the data, we strongly recommend
      verifying the record at the county level before making any hiring
      decisions because of these important data omissions. Please contact us
      with questions or concerns regarding this issue. ***
      <br />
    </p>
    <p className="coverage-content-sub-title">Fresno County</p>
    <p>
      Fresno County Court data contains criminal records on over 11,000
      individuals. Data can contain Defendant Name, Case Number, and File Date.
      This source does not contain dates of birth.
    </p>
    <p>
      Cities in this county are: Tollhouse, Tranquillity, Riverdale, Shaver
      Lake, Squaw Valley, Pinedale, Prather, Raisin, Miramonte, Mono Hot
      Springs, Piedra, Hume, Lakeshore, Laton, Five Points, Friant, Helm, Del
      Rey, Dunlap, Easton, Burrel, Cantua Creek, Caruthers, Auberry, Big Creek,
      Biola, San Joaquin, Sanger, Selma, Orange Cove, Parlier, Reedley, Kerman,
      Kingsburg, Mendota, Fowler, Fresno, Huron, Clovis, Coalinga and Firebaugh.
      <br />
    </p>
    <p className="coverage-content-sub-title">Los Angeles</p>
    <p>
      Los Angeles County Court data contains criminal records on over 970,000
      individuals. Data can contain Defendant Name, DOB, Case Number, and
      Hearing Date.
    </p>
    <p>
      Cities in this county are: Newhall, Windsor Hills, Winnetka, Woodland
      Hills, West Toluca Lake, Westchester, Wilmington, Watts, West Hills, West
      Los Angeles, Verdugo City, View Park, Walnut Park, Valyermo, Van Nuys,
      Venice, Val Verde, Valencia, Valley Village, Topanga, Tujunga, Universal
      City, Sylmar, Tarzana, Toluca Lake, Sun Valley, Sun Village, Sunland,
      Sherman Oaks, Stevenson Ranch, Studio City, Saratoga Hills, Saugus,
      Sepulveda, Rosewood, Rowland Heights, San Pedro, Rancho Park, Reseda,
      Ritter Ranch, Porter Ranch, Quartz Hill, Rancho Dominguez, Pearblossom,
      Phillips Ranch, Playa Del Rey, Pacoima, Palos Verdes Peninsula, Panorama
      City, Oak Park, Oakwood, Pacific Palisades, North Hills, North Hollywood,
      Northridge, Montrose, Mount Wilson, Mount Baldy, Mirada, Mission Hills,
      Monte Nido, Los Angeles Air Force Base, Los Nietos, Marina Del Rey,
      Lincoln Heights, Littlerock, Llano, Leimert Park, Lennox, Leona Valley,
      Lake Hughes, Lake Los Angeles, Lake View Terrace, Hollywood, LaCanada, La
      Crescenta, Hi Vista, Highland Park, Holly Park, Hansen Hills, Harbor City,
      Hazard, Glassell Park, Granada Hills, Hacienda Heights, Firestone Park,
      Flintridge, Glassell, El Sereno, Elizabeth Lake, Encino, Del Sur, East Los
      Angeles, East Rancho Dominguez, Chatsworth, Cornell, Crystalaire, Canyon
      Country, Castaic, Century City, Box Canyon, Calabasas Hills, Canoga Park,
      Baldwin Hills, Bassett, Bell Canyon, Agua Dulce, Altadena, Arleta,
      Whittier, Acton, Agoura, West Covina, West Hollywood, Westlake Village,
      Torrance, Vernon, Walnut, South Gate, South Pasadena, Temple City, Sierra
      Madre, Signal Hill, South El Monte, Santa Clarita, Santa Fe Springs, Santa
      Monica, San Fernando, San Gabriel, San Marino, Rolling Hills Estates,
      Rosemead, San Dimas, Rancho Palos Verdes, Redondo Beach, Rolling Hills,
      Pasadena, Pico Rivera, Pomona, Palmdale, Palos Verdes Estates, Paramount,
      Montebello, Monterey Park, Norwalk, Manhattan Beach, Maywood, Monrovia,
      Los Angeles, Lynwood, Malibu, Lawndale, Lomita, Long Beach, La Verne,
      Lakewood, Lancaster, La Habra Heights, La Mirada, La Puente, Inglewood,
      Irwindale, La Canada Flintridge, Hidden Hills, Huntington Park, Industry,
      Hawaiian Gardens, Hawthorne, Hermosa Beach, Gardena, Glendale, Glendora,
      Duarte, El Monte, El Segundo, Culver City, Diamond Bar, Downey, Compton,
      Covina, Cudahy, Cerritos, Claremont, Commerce, Burbank, Calabasas, Carson,
      Bellflower, Beverly Hills, Bradbury, Baldwin Park, Bell, Bell Gardens,
      Artesia, Avalon, Azusa, Agoura Hills, Alhambra and Arcadia.
      <br />
    </p>
    <p className="coverage-content-sub-title">Orange County</p>
    <p>
      Orange County Court data contains criminal records on over 545,000
      individuals. Data can contain Case Number, Disposition Date, and File
      Date.
    </p>
    <p>
      Cities in this county are: Trabuco Canyon, Sunset Beach, Surfside,
      Trabuco, Robinson Ranch, Rossmoor, Silverado, Newport Coast, Portola
      Hills, Rancho Santa Margarita, Midway City, Monarch Bay, Monarch Beach,
      LaHabra Heights, Ladera Ranch, Laguna Woods, El Toro, Foothill Ranch,
      Cowan Heights, Dove Canyon, East Irvine, Capistrano Beach, Corona del Mar,
      Coto de Caza, Yorba Linda, Aliso Viejo, Atwood, Tustin, Villa Park,
      Westminster, Santa Ana, Seal Beach, Stanton, Placentia, San Clemente, San
      Juan Capistrano, Mission Viejo, Newport Beach, Orange, Laguna Niguel, Lake
      Forest, Los Alamitos, La Palma, Laguna Beach, Laguna Hills, Huntington
      Beach, Irvine, La Habra, Fountain Valley, Fullerton, Garden Grove, Costa
      Mesa, Cypress, Dana Point, Anaheim, Brea, and Buena Park.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from CA, which contained records.
      <br />
    </p>
    <p className="coverage-content-sub-title">Riverside County</p>
    <p>
      (Including Indio Div.) Superior Court filings on felony andafter status
      meeting misdemeanor charges since 1991. Records on approximately 800,000
      persons. Search results show the file date, case number, defendant name,
      DOB, and charges. Note: These are filings ONLY, not dispositions. Records
      updated monthly.
    </p>
    <p>
      Cities in this county are: Winchester, Thousand Palms, White Water,
      Wildomar, Rubidoux, Sun City, Thermal, Quail Valley, Ripley, Romoland,
      Mountain Center, North Palm Springs, Nuevo, Mecca, Menifee, Mira Loma,
      Idyllwild, Lakeview, Eagle Mountain, Gilman Hot Springs, Homeland, Cherry
      Valley, Chiriaco Summit, Desert Center, Aguanga, Anza, Cabazon, Riverside,
      San Jacinto, Temecula, Palm Springs, Perris, Rancho Mirage, Murrieta,
      Norco, Palm Desert, La Quinta, Lake Elsinore, Moreno Valley, Hemet, Indian
      Wells, Indio, Coachella, Corona, Desert Hot Springs, Calimesa, Canyon
      Lake, Cathedral City, Banning, Beaumont, and Blythe.
      <br />
    </p>
    <p className="coverage-content-sub-title">Sacramento County</p>
    <p>
      Sacramento County Court data contains criminal records on over 32,000
      individuals. Data can contain Defendant Name, Case Number, and File Date.
    </p>
    <p>
      Cities in this county are: Walnut Grove, Wilton, Rio Linda, Ryde,
      Sloughhouse, Rancho Cordova, Rancho Murieta, Represa, North Highlands,
      Orangevale, Herald, Hood, Mather, Elverta, Fair Oaks, Gold River, Citrus
      Heights, Courtland, Elk Grove, Sacramento, Antelope, Carmichael, Folsom,
      Galt, and Isleton.
      <br />
    </p>
    <p className="coverage-content-sub-title">San Bernadino County</p>
    <p>
      San Bernadino County Court data contains criminal records on over 760,000
      individuals. Data can contain Defendant Name, Case Number, Statute, and
      File Date.
    </p>
    <p>
      Cities in this county are: Vidal, Wrightwood, Yermo, Twentynine Palms MCB,
      Twin Peaks, Verdemont, Spring Valley Lake, Sugarloaf, Trona, Rimforest,
      Running Springs, Skyforest, Pinon Hills, Pioneertown, Red Mountain, Parker
      Dam, Patton, Phelan, Oak Glen, Oak Hills, Oro Grande, Muscoy, Newberry
      Springs, Nipton, Mentone, Morongo Valley, Mountain Pass, Lucerne Valley,
      Ludlow, Lytle Creek, Kelso, Lake Arrowhead, Landers, Johannesburg, Johnson
      Valley, Joshua Tree, Guasti, Helendale, Hinkley, Forest Falls, Fort Irwin,
      Green Valley Lake, Essex, Etiwanda, Fawnskin, Earp, East Highland, El
      Mirage, Crestline, Daggett, Devore Heights, Cedarpines Park, Cima, Crest
      Park, Bryn Mawr, Cadiz, Cedar Glen, Bloomington, Blue Jay, Blythe, Baker,
      Big Bear City, Big River, Argus, Arrowbear Lake, Arrowhead Farms, Alta
      Loma, Amboy, Angelus Oaks, Victorville, Yucaipa, Yucca Valley, San
      Bernardino, Twentynine Palms, Upland, Rancho Cucamonga, Redlands, Rialto,
      Montclair, Needles, Ontario, Hesperia, Highland, Loma Linda, Colton,
      Fontana, Grand Terrace, Big Bear Lake, Chino, Chino Hills, Adelanto, Apple
      Valley, and Barstow.
      <br />
    </p>
    <p className="coverage-content-sub-title">Santa Barbara County</p>
    <p>
      Santa Barbara County Court data contains criminal records on over 162,000
      individuals. Data can contain Defendant Name, Case Number, Degree Of
      Offense, and Case Date.
    </p>
    <p>
      Cities in this county are: Santa Ynez, Summerland, Montecito, New Cuyama,
      Orcutt, Isla Vista, Los Alamos, Los Olivos, Cuyama, Gaviota, Goleta,
      Solvang, Ballard, Casmalia, Lompoc, Santa Barbara, Santa Maria, Buellton,
      Carpinteria, and Guadalupe.
      <br />
    </p>
    <p className="coverage-content-sub-title">Santa Clara County</p>
    <p>
      Santa Clara County Court data contains criminal records on over 200,000
      individuals. Data can contain Defendant Name, DOB, Case Number, and File
      Date.
    </p>
    <p>
      Cities in this county are: Stanford, Permanente, Redwood Estates, San
      Martin, Mount Hamilton, New Almaden, Alviso, Coyote, Monte Vista, Santa
      Clara, Saratoga, Sunnyvale, Mountain View, Palo Alto, San Jose, Milpitas,
      Monte Sereno, Morgan Hill, Los Altos, Los Altos Hills, Los Gatos,
      Campbell, Cupertino, and Gilroy.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">Santa Cruz County</p>
    <p>
      Santa Cruz County Court data contains criminal records on over 100,000
      individuals. Data can contain Defendant Name, DOB, Case Number, Charge,
      and File Date.
    </p>
    <p>
      Cities in this county are: Pajaro, Royal Oaks, Soquel, Freedom, La Selva
      Beach, Mount Hermon, Corralitos, Davenport, Felton, Bonny Doon, Boulder
      Creek, Brookdale, Watsonville, Aptos, Ben Lomond, Capitola, Santa Cruz,
      and Scotts Valley.
      <br />
    </p>
    <p className="coverage-content-sub-title">Ventura County</p>
    <p>
      Ventura County Court data since 1990 containing criminal records on over
      850,000 individuals. Data can contain defendant name, degree of offense,
      statute, violation date, and case number.
    </p>
    <p>
      Cities in this county are: Ventura, Westlake Village, Point Mugu NAWC,
      Santa Susana, Somis, Oak Park, Oak View, Piru, Hidden Valley, Lake
      Sherwood, Newbury Park, Thousand Oaks, Agoura Hills, Brandeis, San
      Buenaventura (Ventura), Santa Paula, Simi Valley, Ojai, Oxnard, Port
      Hueneme, Camarillo, Fillmore and Moorpark.
      <br />
    </p>
    <p className="coverage-content-sub-title">California Sex Offender</p>
    <p>
      California Sex Offender Records. Data contains name, offense, photos, and
      Birth Dates.
    </p>
    <p>
      Counties in the data include: Alameda, Amador, Butte, Calaveras, Colusa,
      Contra Costa, Del Norte, El Dorado, Fresno, Glenn, Humboldt, Imperial,
      Inyo, Kern, Kings, Lake, Lassen, Los Angeles, Madera, Marin, Mariposa,
      Mendocino, Merced, Modoc, Mono, Monterey, Napa, Nevada, Orange, Placer,
      Plumas, Riverside, Sacramento, San Benito, San Bernardino, San Diego, San
      Francisco, San Joaquin, San Luis Obispo, San Mateo, Santa Barbara, Santa
      Clara, Santa Cruz, Shasta, Sierra, Siskiyou, Solano, Sonoma, Stanislaus,
      Sutter, Tehama, Trinity, Tulare, Tuolumne, Ventura, Yolo, Yuba
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Colorado</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Colorado Statewide</p>
    <p>
      The Colorado Courts Database contains millions of up-to-the-minute court
      records in four major case categories: Criminal, Civil, Traffic and
      Domestic Relations. Certain cases on the database date to the 1960s. The
      database is the publicly available portion of the Integrated Colorado
      On-Line Network, or ICON, which is the official electronic courts
      repository of the Colorado Judicial Branch. ICONs predecessor systems date
      to 1978. The official custodian of ICON is the State Court Administrators
      Office, which is the administrative arm of the Judicial Branch. Results
      available instantly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Colorado Sex Offender</p>
    <p>
      Registry only contains information on certain high-risk registered sex
      offenders. High-risk offenders are categorized as Sexually Violent
      Predator (SVP), Multiple Offenses, and Failed to Register. Data may
      contain name, DOB, address, aliases, offense, category and other
      additional information. Photos included.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from CO, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Connecticut</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">Connecticut Admin of Courts</p>
    <p>
      Court records of statewide felony and misdemeanor dispositions date from
      1998. Records on approximately 437,000 persons. Results may include
      defendant name, DOB, race, sex, offense date, offense description,
      arresting agency, disposition, disposition date, case #, court
      jurisdiction, sentence. Updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Connecticut Dept of Corrections
    </p>
    <p>
      This database contains current and historical felony and misdemeanor
      information for inmates and arrests that are or have been under the
      supervision of the Connecticut Department of Corrections Fsince 1995.
      Limited arrest information is provided. The jurisdiction provides monthly
      updates of the most current data available.
      <br />
    </p>
    <p className="coverage-content-sub-title">Connecticut Sex Offender</p>
    <p>
      Registry contains records, from October 1, 1988, to the present, for
      offenders who have been convicted or found not guilty by reason of mental
      disease or defect. Includes photos.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from CT, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Delaware</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Delaware Sex Offender</p>
    <p>
      Delaware Sex Offender Registry contains only offenders convicted after
      June 24, 1994 for sex offenses specified under Delaware Law. Data includes
      offender photos.
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from DE, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Florida</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
      <br />
    </p>
    <p className="coverage-content-red">
      ***Florida Administration of Courts (FL AOC) NOTICE***
      <br />
      <br />
    </p>
    <p className="coverage-content-red">
      Due to circumstances beyond our control, the Florida Administrative Office
      of Courts will no longer be providing criminal data updates to any company
      which has purchased their data. The FL AOC file was last updated December
      2003. We will continue to build our criminal files in Florida by securing
      data directly from the counties.
      <br />
      <br />
      If you do run the Florida instant search and receive a hit from the FL AOC
      file, we strongly recommend verifying the record at the county level as
      the FL AOC is not providing any verification of the data they have
      supplied in the past. Please contact us with questions or concerns
      regarding this issue.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">Alachua County</p>
    <p>
      Alachua County records of misdemeanor and felony dispositions. Records on
      approximately 362,995 persons. Results include name, address, birth date,
      race, sex, degree of offense, and case number.
    </p>
    <p>
      Cities in this county are: Island Grove, Lochloosa, Santa Fe, Cross Creek,
      Earleton, Evinston, Micanopy, Newberry, Waldo, Hawthorne, High Springs, La
      Crosse, Alachua, Archer and Gainesville.
      <br />
    </p>
    <p className="coverage-content-sub-title">Brevard County</p>
    <p>
      Felony, and Misdemeanor convictions from Brevard Circuit and County courts
      dating back to 1992.
    </p>
    <p>
      Cities in this county are: West Cocoa, Sebastian, Sharpes, Viera, Port
      Canaveral, Port Saint John, Scottsmoor, Micco, Mims, Patrick Air Force
      Base, Indian Harbor Beach, Kennedy Space Center, Merritt Island, Barefoot
      Bay, Canaveral Air Station, Grant, Satellite Beach, Titusville, West
      Melbourne, Palm Bay, Palm Shores, Rockledge, Melbourne Beach, Melbourne,
      Melbourne Village, Indialantic, Indian Harbour Beach, Malabar, Cape
      Canaveral, Cocoa Beach, and Cocoa.
      <br />
    </p>
    <p className="coverage-content-sub-title">Broward County</p>
    <p>
      Circuit and County Clerk of Court Records of individuals convicted of a
      felony or misdemeanor since 1992.
    </p>
    <p>
      Cities in this county are: Wilton Manors, Southwest Ranches, Weston, Sea
      Ranch, Lakes, Sunrise, Tamarac, Pembroke Pines, Plantation, Pompano Bch,
      Oakland, Park, Parkland, Pembroke Park, Margate, Miramar, North
      Lauderdale, Lauderhill, Lazy Lake, Lighthouse Point, Hollywood, Lauderdale
      Lakes, Lauderdale-by-the-Sea, Fort Lauderdale, Hallandale Bch, Hillsboro
      Bch, Dania Beach, Davie, Deerfield Bch, Coconut Creek, Cooper City, and
      Coral Springs.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Charlotte County (Englewood Area)
    </p>
    <p>
      Circuit and County Court criminal convictions for felony, misdemeanor, and
      traffic offenses. Data from 1990 - present. Results may include Case
      Number, Name, Address, SSN, Charges Filed Date, Charge, Disposition Date,
      Disposition Verdict, Sentence.
    </p>
    <p>
      Cities in this county are: Placida, Port Charlotte, Rotonda West, Punta
      Gorda, El Jobean, and Murdock.
      <br />
    </p>
    <p className="coverage-content-sub-title">Clay County</p>
    <p>
      Clay County, FL Courts records of Felony / misdemeanor convictions dating
      back to 1990. Results may include name, date of birth, race, sex, offense,
      offense date, arrest date.
    </p>
    <p>
      Cities in this county are: Middleburg, Penney Farms, Doctors Inlet, Lake
      Geneva, Green Cove Springs, Keystone Heights, and Orange Park.
      <br />
    </p>
    <p className="coverage-content-sub-title">Dade County (Miami Area)</p>
    <p>
      Court records of felony and misdemeanor dispositions since 1980. Records
      on approximately 296,000 persons. Results may include the file date, case
      #, defendant name, DOB, race, sex, charges disposition, disposition date
      and sentence.
    </p>
    <p>
      Cities in this county are: Sweetwater, Virginia Gardens, West Miami,
      Opa-locka, South Miami, Surfside, North Bay Village, North Miami Beach,
      North Miami, Miami, Miami Shores, Miami Springs, Key Biscayne, Medley,
      Miami Beach, Homestead, Indian Creek, Islandia, Golden Beach, Hialeah,
      Hialeah Gardens, Coral Gables, El Portal, Florida City, Bal Harbour, Bay
      Harbor Islands, and Biscayne Park.
      <br />
    </p>
    <p className="coverage-content-sub-title">Duval County</p>
    <p>
      Court records of misdemeanor and felony dispositions dating back to 1985.
      Records on approximately 579,000 persons. Results may include name, DOB,
      race, sex, charges, arrest date, disposition, case number and disposition
      date.
    </p>
    <p>
      Cities in this county are: Atlantic Beach, Baldwin, Bayard, Dinsmore, Fort
      George Island, Jacksonville, Jacksonville Beach, Little Talbot Island,
      Maxville, Mayport, Neptune Beach, Normandy, and Whitehouse.
      <br />
    </p>
    <p className="coverage-content-sub-title">Escambia County</p>
    <p>
      Courts records of Felony / misdemeanor convictions dating back to 1990.
      Results may include name, date of birth, race, sex, offense, offense date,
      arrest date.
    </p>
    <p>
      Cities in this county are: Molino, Walnut Hill, Cantonment, Gonzalez,
      McDavid, Century, Pensacola, and Bellview.
      <br />
    </p>
    <p className="coverage-content-sub-title">Florida Admin Office of Courts</p>
    <p>
      Circuit and District Court records of felony and misdemeanor cases
      disposed in all 67 counties since 1987. Records on approximately 12
      million persons. Results may include case no., name, DOB, race, sex,
      charge(s), county of offense, disposition, disposition date, sentence
      date.
      <br />
    </p>
    <p className="coverage-content-sub-title">Florida Dept of Corrections</p>
    <p>
      Corrections records of statewide criminal convictions and guilty pleas
      (mainly felonies) on persons who have been sentenced to serve time or
      community service, or have received a suspended sentence or probation at a
      state facility since 1979. Records on approximately 1.3 million persons.
      These records include persons guilty of felonies and some state-level
      misdemeanors. Results may include the disposition date, arrest date,
      county, case #, defendant name, DOB, race, sex, charge(s), dispositions
      and sentence. Photos included.
      <br />
    </p>
    <p className="coverage-content-sub-title">Florida Sex Offender</p>
    <p>
      This database contains public record information on offenders classified
      as sexual predators and sexual offenders under Florida law because of a
      conviction for a sex-related crime and/or a specified crime against
      children. WARNINGS: 1) Positive identification cannot be made without a
      fingerprint comparison; and 2) This information is provided as a service
      for the public&rsquo;s benefit and may not be used in the perpetration of
      any criminal act or harassment against these individuals.
      <br />
    </p>
    <p className="coverage-content-sub-title">Hernando County</p>
    <p>
      Data contains felony and misdemeanor information on over 53,000
      individuals. Data can include name, dob, address, offense, statute, case
      number, case date, fines, file date, status, attorneys, and judge.
    </p>
    <p>
      Cities in this county are: Timber Pines, High Point, North Brooksville,
      South Brooksville, Ridge Manor, Spring Hill, Mountain Park, Istachatta,
      Masaryktown, Nobleton, Brooksville, Weeki Wachee, and Hernando Beach.
      <br />
    </p>
    <p className="coverage-content-sub-title">Highlands County</p>
    <p>
      Data contains misdemeanor and felony information on over 29,000
      individuals since 1991. Data can include name, DOB, address, case number,
      offense, offense date, statute, and file date.
    </p>
    <p>
      Cities in this county are: Lorida, Venus, Avon Park, Lake Placid and
      Sebring.
      <br />
    </p>
    <p className="coverage-content-sub-title">Hillsborough County</p>
    <p>
      Court filings on felony and misdemeanor charges since 1987. Records on
      approximately 279,000 persons. Results may include the file date, case #,
      defendant name, DOB, race, sex and charges. Note: These are filings ONLY,
      not dispositions.
    </p>
    <p>
      Cities in this county are: Valrico, Wimauma, Sun City Center, Sydney,
      Thonotosassa, Ruskin, Seffner, Sun City, Mango, Odessa, Riverview,
      Gibsonton, Lithia, Lutz, Carrollwood, Dover, Durant, Apollo Beach, Balm,
      Brandon, Plant City, Tampa, and Temple Terrace.
      <br />
    </p>
    <p className="coverage-content-sub-title">Lee County</p>
    <p>
      Courts records of Felony / misdemeanor convictions dating back to 1974.
      Results may include name, date of birth, race, sex, offense, offense date,
      arrest date.
    </p>
    <p>
      Cities in this county are: Pineland, Saint James City, Tice, Matlacha,
      North Fort Myers, Page Field, Estero, Fort Myers Beach, Lehigh Acres,
      Bokeelia, Bonita Springs, Captiva, Alva, Barefoot Beach, Boca Grande, Cape
      Coral, Fort Myers, and Sanibel.
      <br />
    </p>
    <p className="coverage-content-sub-title">Leon County</p>
    <p>
      Data contains felony and misdemeanor information on over 17,000
      individuals. Data can include name, dob, offense, degree of offense,
      statute, and file date.
    </p>
    <p>
      Cities in this county are: Miccosukee Cpo, Woodville, Tallahassee, Florida
      A and M University, and Florida State University.
      <br />
    </p>
    <p className="coverage-content-sub-title">Monroe County</p>
    <p>
      Courts records of Felony / misdemeanor convictions. Results may include
      name, date of birth, race, sex, offense, offense date, arrest date.
    </p>
    <p>
      Cities in this county are: Upper Sugarloaf Key, The Villages (part),
      Sugarloaf, Key, Sugarloaf Shores, Tavernier, Ocean Reef, Ramrod Key,
      Sugarloaf, Marathon, Marathon Shores, Middle Torch Key, Little Torch Key,
      Long Key, Lower Sugarloaf, Key, Grassy Key, Key Largo, Key West Naval Air
      Station, Cudjoe Key, Duck Key, East Rockland Key, Big Pine Key, Big Torch
      Key, Conch Key, Key Colony Beach, Key West, and Layton.
      <br />
    </p>
    <p className="coverage-content-sub-title">Orange County</p>
    <p>
      Court records on felony and misdemeanor dispositions since 1990. Records
      on approximately 229,500 persons. Results may include the file date,
      sentence date, case #, defendant name, DOB, race, sex, charges and
      sentence.
    </p>
    <p>
      Cities in this county are: Zellwood, Sand Lake, South Creek, Tangerine,
      Orlo, Vista, Pine Castle, Plymouth, Hiawassee, Killarney, Lockhart,
      Christmas, Clarcona, Gotha, Winter Park, Aloma, Azalea Park, Orlando,
      Windermere, Winter, Garden, Maitland, Oakland, Ocoee, Eatonville,
      Edgewood, Lake Buena Vista, Apopka, Bay Lake, and Belle Isle.
      <br />
    </p>
    <p className="coverage-content-sub-title">Osceola County</p>
    <p>
      Data contains felony and misdemeanor information on over 518,000
      individuals. Data can include name, dob, offense, degree of offense,
      disposition, disposition date, sentence and file date.
    </p>
    <p>
      Cities in this county are: Poinciana, Celebration, Intercession City,
      Kenansville, Kissimmee, Saint Cloud, and Buena Ventura Lakes.
      <br />
    </p>
    <p className="coverage-content-sub-title">Palm Beach County</p>
    <p>
      Court records of misdemeanor and felony dispositions dating back to 1990.
      Records on approximately 183,000 persons. Results may include name, DOB,
      race, sex, charges, arrest date, disposition, case number and disposition
      date.
    </p>
    <p>
      Cities in this county are: Village of Golf, Village of Wellington, West
      Delray, Beach, Lake Harbor, Loxahatchee, Singer Island, West Palm Beach,
      Bryant, Canal Point, South Bay, South Palm Beach, Tequesta, Palm Springs,
      Riviera Beach, Royal Palm Beach, Palm Beach Gardens, Palm Beach Shores,
      Palm Beach, North Palm Beach, Ocean Ridge, Pahokee, Lantana, Manalapan,
      Mangonia Park, Lake Clarke Shores, Lake Park, Lake Worth, Juno Beach,
      Jupiter Inlet Colony, Jupiter, Haverhill, Highland Beach, Hypoluxo,
      Golfview, Greenacres, Gulf Stream, Delray Beach, Glen Ridge, Golf, Boynton
      Beach, Briny Breezes, Cloud Lake, Atlantis, Belle Glade, and Boca Raton.
    </p>
    <p className="coverage-content-sub-title">Pinellas County</p>
    <p>
      Court records of Felony dispositions since 1990. Records on approximately
      239,000 persons. Results may include case number, defendant name, DOB,
      race, sex, charges, disposition, disposition date, and sentence. Updated
      quarterly.
    </p>
    <p>
      Cities in this county are: Saint Petersburg Beach, Tierra Verde, Crystal
      Beach, Ozona, Palm Harbor, Bay Pines, Belleair Shores, Clearwater Beach,
      Saint Petersburg, Tarpon Springs, Treasure Island, Seminole, South
      Pasadena, Saint Pete Beach, Redington Beach, Redington Shores, Safety
      Harbor, North Redington Beach, Oldsmar, Pinellas Park, Kenneth City,
      Largo, Madeira Beach, Gulfport, Indian Rocks Beach, Indian Shores,
      Belleair, Clearwater, Dunedin, Belleair Beach, Belleair Bluffs, and
      Belleair Shore.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from FL, which contained records.
      <br />
    </p>
    <p className="coverage-content-sub-title">Sarasota County</p>
    <p>
      Misdemeanor and felony records on over 343,000 individuals dating back to
      1974. Data may contain name, date of birth, race, sex, offenses,
      disposition, case number, and file date.
    </p>
    <p>
      Cities in this county are: Osprey, Pinecraft, Grove City, Laurel, Nokomis,
      Venice, Englewood, Fruitville, Longboat Key (part), North Port, and
      Sarasota.
      <br />
    </p>
    <p className="coverage-content-sub-title">Suwannee County</p>
    <p>
      Data contains felony and misdemeanor information on over 6,700
      individuals. Data can include name, dob, offense, degree of offense,
      disposition date, and file date.
    </p>
    <p>
      Cities in this county are: Wellborn, Branford, Live Oak and O&apos;Brien.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Georgia</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Georgia Bureau of Investigation
    </p>
    <p>
      Data contains information on more than 445,000 individuals who have been
      convicted on felony charges in Georgia since the early 1970s. Data may
      include name, DOB, offense, and disposition date. Updated every 6 months.
      <br />
    </p>
    <p className="coverage-content-red">
      ***ATTENTION!!! Effective 4/10/05, only the Year of Birth will be
      available.***
      <br />
    </p>
    <p className="coverage-content-sub-title">Georgia Dept of Corrections</p>
    <p>
      Department of Corrections records for statewide felony criminal
      convictions and guilty pleas of individuals sentenced to serve time,
      community service, or have received suspended sentence, parole, or
      probation at any state facility since 1979. Data represents over 1 million
      persons guilty of felonies and some state-level misdemeanors. Results may
      include offense, offense date, sentence, sentence date, probation, release
      date, as well as personal information including address, date of birth,
      height, weight, race, and sex. Photos included. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Georgia Sex Offender</p>
    <p>
      Georgia Sex Offender Registry records. Results may include offenders
      either released from prison or placed on probation, parole or supervised
      release after July 1, 1996. Photos included. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from GA, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Hawaii</p>
    <p className="coverage-content-red">
      <br />
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">Hawaii Sex Offender</p>
    <p>
      Hawaii Sex Offender Registry includes offenders living in Hawaii who have
      been given a court hearing to determine if that information of person
      shall be made public. Information about those persons, which is available
      to the public includes: name, photograph, street name of residence, and
      crime for which convicted.Photos included.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S. ONLY</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from HI, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Idaho</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
    </p>
    <p>
      <br />
    </p>
    <p className="coverage-content-sub-title">Idaho Dept of Corrections</p>
    <p>
      Corrections records of statewide records of persons convicted of felonies
      and sentenced to serve time in a state facility, probation, or parole or
      suspended sentence since 1995. Records on approximately 50,000 persons.
      Records updated twice annually. Results may include defendant name, DOB,
      race, sex, sentence date, offense description, case #, court jurisdiction,
      sentence. Records update twice annually.
      <br />
    </p>
    <p className="coverage-content-sub-title">Idaho Sex Offender</p>
    <p>
      Registry contains information on over 2400 individuals, dating back to
      July 1, 1993. Data may contain name, DOB, address, offense, conviction
      place, and conviction date.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from ID, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Illinois</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Carroll County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1988.
    </p>
    <p>
      Cities in this county are: Wysox Township, York Township, Thomson,
      Washington Township, Woodland Township, Salem Township, Savanna Township,
      Shannon, Milledgeville, Mount Carroll (part), Rock Creek-Lima Township,
      Fairhaven Township, Freedom Township, Lanark, Chadwick, Cherry
      Grove-Shannon Township and Elkhorn Grove Township.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">Coles County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1989.
    </p>
    <p>
      Cities in this county are: Pleasant Grove Township, Seven Hickory
      Township, Trilla, North Okaw Township, Oakland, Paradise Township, Lerna,
      Mattoon (part), Morgan Township, Humboldt Township, Hutton Township,
      Lafayette Township, Ashmore Township, Charleston (part) and East Oakland
      Township.
      <br />
    </p>
    <p className="coverage-content-sub-title">Cook County</p>
    <p>
      Cook County Criminal Records contains felony and misdemeanor information
      on nearly 400,000 individuals. Results may include name, dob, address,
      offense, degree of offense, fine, arrest date and disposition information.
    </p>
    <p>
      Cities in this county are: Techny, Mount Greenwood, Ontarioville, Summit
      Argo, Hines, Jefferson Park, La Grange Highlands, AMF O&apos;Hare, Argo,
      Glenview NAS, Wilmette (part), Winnetka, Worth (part), Western Springs
      (part), Wheeling (part), Willow Springs (part), Tinley Park (part),
      University Park (part), Westchester, Streamwood (part), Summit, Thornton
      Township, Steger (part), Stickney Township, Stone Park, South Barrington
      (part), South Chicago Heights, South Holland, Schaumburg (part), Schiller
      Park, Skokie, Roselle (part), Rosemont (part), Sauk Village (part),
      Riverside (part), Robbins (part), Rolling Meadows (part), River Forest
      Township, River Grove, Riverdale (part), Proviso, Township, Rich Township,
      Richton Park, Phoenix, Posen (part), Prospect Heights (part), Palos
      Township, Park Forest (part), Park Ridge (part), Palos Heights (part),
      Palos Hills, Palos Park, Orland Park (part), Orland Township, Palatine
      (part), Oak Park Township, Olympia Fields (part), Orland Hills, Oak Brook
      (part), Oak Forest, Oak Lawn, Northfield (part), Northlake (part), Norwood
      Park Township, Norridge (part), North Riverside (part), Northbrook (part),
      Mount Prospect (part), New Trier Township, Niles (part), Merrionette Park,
      Midlothian, Morton Grove (part), Maywood, McCook, Melrose Park (part),
      Maine Township, Markham (part), Matteson, Lincolnwood, Lynwood, Lyons
      (part), Lansing (part), Lemont Township, Leyden Township, Kenilworth, La
      Grange Park, La Grange, Indian Head Park, Inverness (part), Justice,
      Hoffman Estates (part), Hometown, Homewood (part), Hillside, Hinsdale
      (part), Hodgkins, Harwood Heights, Hazel Crest (part), Hickory Hills
      (part), Hanover Park (part), Hanover Township, Harvey (part), Glenview
      (part), Glenwood (part), Golf Forest View, Franklin Park, Glencoe (part),
      Flossmoor (part), Ford Heights, Forest Park, Elmwood Park, Evanston
      Township, Evergreen Park, Elgin (part), Elk Grove Township, Elk Grove
      Village (part), Dolton, East Dundee (part), East Hazel Crest, Deerfield
      (part), Des Plaines (part), Dixmoor, Country Club Hills (part),
      Countryside, Crestwood (part), Chicago Heights, Chicago Ridge, Cicero,
      Calumet Park, Calumet Township, Chicago (part), Burnham, Burr Ridge
      (part), Calumet City, Brookfield (part), Buffalo Grove (part), Burbank
      Bremen Township, Bridgeview (part), Broadview, Berwyn Township, Bloom
      Township, Blue Island (part), Bellwood, Bensenville (part), Berkeley,
      Barrington (part), Bartlett (part), Bedford Park (part), Alsip, Arlington
      Heights (part), and Barrington Hills (part)
      <br />
    </p>
    <p className="coverage-content-sub-title">Henry County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1989.
    </p>
    <p>
      Cities in this county are: Opheim, Woodhull (part), Yorktown Township,
      Lynn Center, Weller Township, Western Township, Wethersfield Township,
      Osco Township, Oxford Township, Phenix Township, Lynn Township, Munson
      Township, Orion, Hooppole, Kewanee (part), Loraine Township, Geneseo,
      Green Rock, Hanna Township, Cornwall Township, Edford Township, Galva
      Township, Clover Township, Coal Valley (part), Colona Township, Burns
      Township, Cambridge Township, Cleveland (part), Annawan Township, Atkinson
      (part), Bishop Hill, Alba Township, Alpha and Andover Township.
      <br />
    </p>
    <p className="coverage-content-sub-title">Illinois Dept of Corrections</p>
    <p>
      Corrections records of Illinois statewide felony convictions on persons
      found guilty and sentenced to serve time and/or subsequent probation in a
      state penal institution. Includes probation and parole information where
      applicable. Records on approximately 200,000 persons dating to 1986.
      Results may include defendant name, DOB, race, sex, offense date, offense
      description, disposition, disposition date, case #, county of disposition,
      sentence. Records updated quarterly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Illinois Sex Offender</p>
    <p>
      Illinois Sex Offender Registry contains information on over 17,000
      individuals. Data may contain name, dob, address, offense, and victim age.
      Photos included.
      <br />
    </p>
    <p className="coverage-content-sub-title">Jackson County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1985.
    </p>
    <p>
      Cities in this county are: Jacob, Oraville, Sand Ridge Township, Somerset
      Township, Vergennes Township, Murphysboro (part), Ora Township, Pomona
      Township, Kinkaid Township, Levan Township, Makanda, Fountain Bluff
      Township, Gorham, Grand Tower, Dowell, Elk Township, Elkville, Carbondale,
      De Soto Township, Degognia Township, Ava, Bradley Township and Campbell
      Hill.
      <br />
    </p>
    <p className="coverage-content-sub-title">Jo Daviess County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1992.
    </p>
    <p>
      Cities in this county are: Woodbine Township, Wards Grove Township, Warren
      Township, West Galena Township, Stockton Township, Thompson Township,
      Vinegar Hill Township, Rice Township, Rush Township, Scales Mound, Nora
      Township, Pleasant Valley Township, Rawlins Township, Guilford Township,
      Hanover Township, Menominee Township, East Galena Township, Elizabeth
      (part), Galena (part), Derinda Township, Dunleith Township, East Dubuque,
      Apple River Township, Berreman Township and Council Hill Township.
      <br />
    </p>
    <p className="coverage-content-sub-title">Lee County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1989.
    </p>
    <p>
      Cities in this county are: Wyoming Township, Eldena, Viola Township, West
      Brooklyn, Willow Creek Township, South Dixon Township, Steward, Sublette
      Township, Palmyra Township, Paw Paw, Reynolds Township, May Township,
      Nachusa Township, Nelson Township, Lee Center Township, Lee (part), Marion
      Township, Franklin Grove, Hamilton Township, Harmon Township, Compton,
      Dixon (part), East Grove Township, Bradford Township, Brooklyn Township,
      China Township, Alto Township, Amboy and Ashton.
      <br />
    </p>
    <p className="coverage-content-sub-title">Logan County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1989.
    </p>
    <p>
      Cities in this county are: Lawndale, Beason, Chestnut, Cornland, San Jose
      (part), Sheridan Township, West Lincoln Township, Oran Township, Orvil
      Township, Prairie Creek Township, Middletown, Mount Pulaski Township, New
      Holland, Lake Fork Township, Latham, Lincoln (part), Hartsburg, Hurlbut
      Township, Laenna Township, Elkhart Township, Emden, Eminence Township,
      Chester Township, Corwin Township, East Lincoln Township, Aetna Township,
      Atlanta and Broadwell.
      <br />
    </p>
    <p className="coverage-content-sub-title">Mercer County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1988.
    </p>
    <p>
      Cities in this county are: New Windsor, Suez Township, Viola, Windsor,
      Rivoli Township, Seaton, Sherrard, Preemption Township, Reynolds (part),
      Richland Grove Township, North Henderson Township, Ohio Grove Township,
      Perryton Township, Mercer Township, Millersburg Township, New Boston
      Township, Joy, Keithsburg, Matherville, Duncan Township, Eliza Township,
      Greene Township, Abington Township, Aledo and Alexis (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Ogle County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1989.
    </p>
    <p>
      Cities in this county are: Kings, Lindenwood, Monroe Center, Chana, Egan,
      Holcomb, White Rock Township, Woosung Township, Baileyville, Scott
      Township, Stillman Valley (part), Taylor Township, Polo, Rochelle (part),
      Rockvale Township, Oregon, Pine Creek Township, Pine Rock Township, Monroe
      Township, Mount Morris Township, Nashua Township, Lynnville Township,
      Marion Township, Maryland Township, Lafayette Township, Leaf River
      Township, Lincoln Township, Forreston Township, Grand Detour Township,
      Hillcrest, Dement Township, Eagle Point Township, Flagg Township, Byron,
      Creston, Davis Junction, Adeline, Brookville Township and Buffalo
      Township.
      <br />
    </p>
    <p className="coverage-content-sub-title">Pike County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1991.
    </p>
    <p>
      Cities in this county are: Rockport, Summer Hill, Spring Creek Township,
      Time, Valley City, Pleasant Hill Township, Pleasant Vale Township, Ross
      Township, Pearl Township, Perry Township, Pittsfield (part), New Canton,
      New Salem Township, Newburg Township, Milton, Montezuma Township, Nebo,
      Kinderhook Township, Levee Township, Martinsburg Township, Hadley
      Township, Hardin Township, Hull, Flint Township, Florence, Griggsville
      Township, Detroit Township, El Dara, Fairmount Township, Chambersburg
      Township, Cincinnati Township, Derry Township, Atlas Township, Barry
      (part) and Baylis.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from IL, which contained records.
      <br />
    </p>
    <p className="coverage-content-sub-title">Rock Island County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1989.
    </p>
    <p>
      Cities in this county are: Illinois City, Taylor Ridge, South Rock Island
      Township, Zuma Township, Barstow, Rural Township, Silvis, South Moline
      Township, Rapids City (part), Reynolds (part), Rock Island (part), Moline
      (part), Oak Grove (part), Port Byron (part), Hampton Township, Hillsdale,
      Milan (part), Drury Township, East Moline (part), Edgington Township, Coal
      Valley (part), Coe Township, Cordova (part), Buffalo Prairie Township,
      Canoe Creek Township, Carbon Cliff, Andalusia Township, Blackhawk Township
      and Bowling Township.
      <br />
    </p>
    <p className="coverage-content-sub-title">Stephenson County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1989.
    </p>
    <p>
      Cities in this county are: Scioto Mills, Winslow Township, Eleroy,
      McConnell, Silver Creek Township, Waddams Township, West Point Township,
      Rock City, Rock Grove Township, Rock Run Township, Orangeville, Pearl
      City, Ridott Township, Lena (part), Loran Township, Oneco Township,
      Jefferson Township, Kent Township, Lancaster Township, Freeport Township,
      German Valley, Harlem Township, Davis, Erin Township, Florence Township,
      Buckeye Township, Cedarville (part) and Dakota Township.
      <br />
    </p>
    <p className="coverage-content-sub-title">Union County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1986.
    </p>
    <p>
      Cities in this county are: Millcreek, Wolf Lake, Dongola, Jonesboro, Mill
      Creek, Alto Pass, Anna and Cobden.
      <br />
    </p>
    <p className="coverage-content-sub-title">Vermilion County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1989.
    </p>
    <p>
      Cities in this county are: Clarence, Collison, East Lynn, Westville
      (part), Armstrong, Bismarck, South Ross Township, Tilton, Vance Township,
      Ross Township, Rossville (part), Sidell Township, Potomac, Rankin, Ridge
      Farm, Newell Township, Oakwood Township, Pilot Township, McKendree
      Township, Middlefork Township, Muncie, Indianola, Jamaica Township, Love
      Township, Grant Township, Henning, Hoopeston, Fairmount, Fithian,
      Georgetown, Catlin Township, Danville (part), Elwood Township, Blount
      Township, Butler Township, Carroll Township, Allerton (part), Alvin and
      Belgium (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Whiteside County</p>
    <p>
      Data may include offender name, birth date, offense, disposition,
      disposition date, degree of offense, and case number. NOTE: This data is
      not complete and may not contain all Charges and Dispositions for an
      offender. Data goes back to 1989.
    </p>
    <p>
      Cities in this county are: Union Grove Township, Ustick Township, Galt,
      Rock Falls, Sterling, Tampico Township, Newton Township, Portland
      Township, Prophetstown Township, Montmorency Township, Morrison (part),
      Mount Pleasant Township, Hume Township, Jordan Township, Lyndon Township,
      Genesee Township, Hahnaman Township, Hopkins Township, Fenton Township,
      Fulton (part), Garden Plain Township, Coloma Township, Deer Grove, Erie
      Township, Albany Township, Clyde Township and Coleta.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Indiana</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Indiana Dept of Corrections</p>
    <p>
      Corrections records of statewide criminal records on persons who have been
      convicted of felonies as and sentenced to serve jail time since 1962.
      These records include persons guilty of felonies and some state-level
      misdemeanors. Results may include the sentence date, county, case #,
      defendant name, DOB (month and year only), race, sex, charge(s), and
      sentence. Records updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Indiana Sex Offender</p>
    <p>
      Contains Information on convicted sex &amp; violent offenders submitted to
      the Indiana Criminal Justice Institute since July 1, 1994; released
      between April 1989 and July 1994 from the Indiana Department of
      Corrections; convicted of a qualifying offense between April 1989 &amp;
      July 1994 as listed by the Indiana Prosecuting Attorney&apos;s Council;
      convicted of a qualifying offense between the year 1919 and July 1994 as
      listed in records maintained by the Indiana State Police. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from IN, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Iowa</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Iowa Admin Office of Courts</p>
    <p>
      This database contains felony and misdemeanor records of individuals who
      are or have been under the jurisdiction of the Iowa Court System. Data is
      available for cases from 7/11/1999 to 12/31/1999 and from 1/1/2004 to
      8/20/2004. Data may contain offender name, birth date, crime charged,
      statute, and disposition.
      <br />
    </p>
    <p className="coverage-content-sub-title">Iowa Dept of Corrections</p>
    <p>
      Corrections records of felony and high-level misdemeanor records on
      persons sentenced to serve time in a state correctional institution since
      1982. Contains records on approximately 39,000 persons. Results may
      include name, DOB, race, sex, county, charge, level of offense, file date,
      sentence date. Updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Iowa DOC Pardons and Parole</p>
    <p>
      Iowa DOC Pardons and Parole. Probation records on all offenders currently
      on probation under the jurisdiction of the state probation office for
      offenses committed since 1975. Records show name, DOB, race, sex, case
      number, county/jurisdiction, charge, file date and sentence. Records
      updated quarterly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Iowa Sex Offender</p>
    <p>
      Data contains individuals, with photos, who have been convicted or
      adjudicated of a criminal offense against a minor, sexual exploitation, or
      a sexually violent crime or who was on probation, parole, or work release
      status, or who was incarcerated on or after July 1, 1995 is required to
      register. Registration does include individuals that have received a
      deferred sentence or deferred judgments and can include convictions from
      other jurisdictions such as other states and/or federal convictions.
      Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from IA, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Kansas</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Kansas Dept of Corrections</p>
    <p>
      Corrections records of persons convicted of felony and gross misdemeanor
      offenses and sentenced to serve time in a state correctional facility
      since 1987, or placed on probation and who have been released or paroled.
      Records on approximately 50,000 persons. Records include name, DOB, race,
      sex, county of offense, case number, offense description, statute,
      disposition date, level of offense.
      <br />
    </p>
    <p className="coverage-content-sub-title">Kansas Sex Offender</p>
    <p>
      Kansas Sex Offender Registry records. Data contains information, including
      photos, on convicted offenders who committed their offenses after April
      14, 1994
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from KS, which contained records.
      <br />
    </p>
    <p className="coverage-content-sub-title">Sedgwick County</p>
    <p>
      Data contains criminal records on over 50,000 individuals. Data can
      contain Name, Degree of Offense, File Date, Disposition Date. This source
      does not contain dates of birth.
    </p>
    <p>
      Cities in this county are: Peck, Wichita, Greenwich, Valley Center (part),
      Viola, Waco Township, Sedgwick (part), Sherman Township, Union Township,
      Riverside Township, Rockford Township, Salem Township, Park City (part),
      Park Township, Payne Township, Mulvane (part), Ninnescah Township, Ohio
      Township, Minneha Township, Morton Township, Mount Hope, Kechi, Lincoln
      Township, Maize, Gypsum Township, Haysville (part), Illinois Township,
      Grand River Township, Grant Township, Greeley Township, Erie Township,
      Garden Plain, Goddard (part), Derby (part), Eagle Township, Eastborough,
      Clearwater, Colwich, Delano Township, Bel Aire, Bentley, Cheney, Afton
      Township, Andale and Attica Township.
    </p>
    <p className="long-line">
      <br />
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Kentucky</p>
    <p className="long-line">
      <br />
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Kentucky Dept of Corrections</p>
    <p>
      Corrections records of statewide criminal records on persons who have been
      convicted of felonies as defined by Kentucky state law and sentenced to
      serve jail time since 1982. Records on approximately 87,000 persons.
      Results may include the date of crime, county of crime, sentence date,
      case #, name, DOB, race, sex, charge(s), and sentence. Records updated
      monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Kentucky Sex Offender</p>
    <p>
      Data provided by the Kentucky State Police Sex/Criminal Offender Registry.
      Contains over 3,000 registered sex offenders with photos. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from KY, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p>
      <br />
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Louisiana</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Bossier Parish</p>
    <p>
      Bossier Parish criminal records containing information on over 200,000
      individuals. Data can include name, offense, file date, and case number.
      Updates unavailable at this time. Possible restart of updates: End of 4th
      quarter 2004.
    </p>
    <p>
      Cities in this county are: Elm Grove, Princeton, Plain Dealing, Shreveport
      (part), Benton, Bossier City, and Haughton.
      <br />
    </p>
    <p className="coverage-content-sub-title">Caddo Parish</p>
    <p>
      Caddo Parish criminal records containing information on over 100,000
      individuals. Data can include name, offense, file date, status, and case
      number. Updates unavailable at this time. Possible restart of updates: End
      of 4th quarter 2004.
    </p>
    <p>
      Cities in this county are: Keithville, Mira, Trees, Caspiana, Dixie,
      Forbing, Shreveport (part), Vivian, Bethany, Mooringsport, Oil City,
      Rodessa, Greenwood, Hosston, Ida, Belcher, Blanchard, and Gilliam.
      <br />
    </p>
    <p className="coverage-content-sub-title">Lousiana Sex Offender</p>
    <p>
      Registry contains information about individuals convicted after July 1,
      1997, for the commission or attempted commission of a sex offense or a
      criminal offense against a victim who is a minor. Data can include name of
      the offender, address of offender, crime for which offender was convicted,
      date and place of conviction, any aliases used by the offender, and photo
      of offender. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from LA, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Maine</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Maine Dept of Corrections</p>
    <p>
      Corrections records of statewide felony and state-level misdemeanor
      convictions on persons who have been sentenced to serve time at a state
      facility since 1985. Records on approximately 13,000 persons. Results may
      include the date of crime, county, case #, defendant name, DOB, race, sex,
      charge(s), sentence and release date. Records updated quarterly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Maine Sex Offender</p>
    <p>
      Registry contains data on individuals that have been sentenced as a sex
      offender or a sexually violent predator on or after June 30, 1992.
      Registry does not include all individuals convicted of a sex crime. Data
      may include name, address, offense, date of sentence, date convicted,
      sentence, statute, and court. Photos included.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from ME, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Maryland</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Maryland Dept of Corrections</p>
    <p>
      Data from the Maryland Department of Corrections containing information on
      over 25,000 individuals. Data can include name, date of birth, offense,
      and holding facility.
      <br />
    </p>
    <p className="coverage-content-sub-title">Maryland Sex Offender</p>
    <p>
      Registry contains information on over 3000 individuals. Data can include
      name, offense, category, and absconder status. Photos included.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from MD, which contained records.
    </p>
    <p className="long-line">
      <br />
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Massachusetts</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
    </p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-sub-title">Massachusetts Sex Offender</p>
    <p>
      Massachusetts Sex Offender Registry of Level Three offenders. Level Three
      offenders have been determined to be at the highest risk for re-offense
      out of all of the three risk levels. Data can include name, offense,
      conviction date, and county. Birth dates are not included. Updated
      Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from MA, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Michigan</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
    </p>
    <p>
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Mississippi Dept of Corrections
    </p>
    <p>
      Sentencing records of felony convictions from all counties&apos; Circuit
      Courts since 1976 of persons sentenced to probation or time in a state
      institution; includes records on parolees. Records on about 150,000
      persons. Results may include name, DOB, race, sex, charge, county of
      offense, disposition, disposition date, sentence, probation or parole
      status and related dates. Records updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Mississippi Sex Offender</p>
    <p>
      Mississippi Sex Offender Records. Data can contain offense, address, crime
      location, and photo. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Hinds County</p>
    <p>
      Hinds County data contains criminal records on over 18,000 individuals.
      Data can contain Offense, Case Number, Sentence, Disposition, and Arrest
      Date.
    </p>
    <p>
      Cities in this county are: Tougaloo, Terry, Utica, Pocahontas, Jackson
      (part), Learned, Raymond, Bolton, Clinton, and Edwards.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from MS, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Minnesota</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
    </p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-sub-title">Minnesota Courts</p>
    <p>
      Administrative records on statewide criminal convictions on persons who
      have been convicted of felonies and/or gross misdemeanors as defined by
      Minnesota state law and sentenced to serve jail time, or probation, or
      parole or suspended sentence since 1982. Records on over 250,000 persons.
      Results may include the disposition date, arresting agency, case #,
      defendant name, DOB, race, sex, charge(s), dispositions and sentence.
      <br />
    </p>
    <p className="coverage-content-sub-title">Minnesota Dept of Corrections</p>
    <p>
      Department of Corrections data contains information on over 100,000
      individuals. Results may include offender name, offense, statute,
      sentence, admission date, and release date.
    </p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-sub-title">Minnesota Sex Offender</p>
    <p>
      Minnesota Sex Offender Registry of Level Three offenders. Level Three
      offenders have been determined to be at the highest risk for re-offense
      out of all of the three risk levels. Photos available.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from MN, which contained records.
    </p>
    <p className="long-line">
      <br />
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Missouri</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected. <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">Missouri Dept of Corrections</p>
    <p>
      Corrections records of statewide felonies on persons who have been
      sentenced to serve time in a state institution, or probation, community
      service or diversion since 1980. Records on approximately 236,000 persons.
      Results may include defendant name, DOB, race, sex, offense date, offense
      description, county of offense, disposition date, case #, sentence.
      Records updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Missouri Sex Offender</p>
    <p>
      This statewide file, maintained by the State Highway Police, dates back to
      1979. Information refers only to persons who have been convicted of, found
      guilty of, or plead guilty to committing or attempting to commit sexual
      offenses and may not reflect the entire criminal history of a particular
      individual. Offenders required to register for crimes of kidnapping,
      felonious restraint, or child abuse may not be listed. Data may include
      offender name, county, offense, and last known address. No birthdates are
      available.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from MO, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Montana</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Montana Dept of Corrections</p>
    <p>
      This database contains offenders who are incarcerated at Montana State
      Prison, Montana Women&apos;s Prison, a regional prison, or a county jail
      awaiting transfer to a prison since 1994. Inmates are either offenders who
      have been sentenced to serve their time in prison by the district court,
      parole violators whose parole has been revoked by the Board of Pardons and
      Parole, probation violators whose probation has been revoked by the
      district court, or Department of Corrections commitments where the
      department has determined that prison is appropriate placement for their
      sentence. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Montana Sex Offender</p>
    <p>
      Registry contains records dating back to 1989 of over 2500 sexual and
      violent offenders. Results may include offense, address, risk level,
      offender type, and photo. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from MT, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Nebraska</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Nebraska Dept of Corrections</p>
    <p>
      Corrections records of felony and high-level misdemeanor records on
      persons sentenced to serve time in a state correctional institution since
      1935. Contains records on approximately 29,000 persons. Results may
      include name, DOB, race, sex, county, charge, level of offense, sentence,
      sentence date. Updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Nebraska Sex Offender</p>
    <p>
      Registry contains records of High Risk/Level 3 Sex Offenders. Data can
      contain offense, address, risk level, jurisdiction, conviction date, and
      photo. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from NE, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Nevada</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Nevada Dept of Corrections</p>
    <p>
      Contains information about currently incarcerated inmates, as well as
      those who have discharged their sentence(s) within the last 18 months. The
      data can include Offense, Date of Birth, and Sentence information.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from NV, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">New Hampshire</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
    </p>
    <p>
      <br />
    </p>
    <p className="coverage-content-sub-title">
      New Hampshire Dept of Corrections
    </p>
    <p>
      This repository contains current and historical data of individuals within
      the New Hampshire Division of Corrections and offenders supervised by the
      Division of Parole &amp; Probation since 1997. No upates available.
      Current thru 4/3/2002.
      <br />
    </p>
    <p className="coverage-content-sub-title">New Hampshire Sex Offender</p>
    <p>
      New Hampshire Sex Offender Registry contains information on sexual
      offenders or offenders against children who have outstanding arrest
      warrants and have not registered. The Registry also contains information
      on registered offenders who have committed crimes against children.
      Results may include name, dob, address, offense, offense date, court,
      photos and photo date.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from NH, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">New Jersey</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">New Jersey Courts</p>
    <p>
      Superior Court records of statewide felony convictions disposed since
      1994. Results may include case no., name, DOB, charge(s), sentence date.
      Records updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">New Jersey Dept of Corrections</p>
    <p>
      Corrections records of statewide felony convictions of persons
      incarcerated in all state facilities since 2000, including those who have
      been released or paroled. Results may include defendant name, DOB, sex,
      offense description, case #, county of offense, sentence date and release
      or parole date. Records updated semi-annually (July &amp; December).
      <br />
    </p>
    <p className="coverage-content-sub-title">New Jersey Sex Offender</p>
    <p>
      The sex offender registry includes information pertaining to sex offenders
      determined to pose a relatively high risk of re-offense (tier 3 offenders)
      and, with certain exceptions, information about sex offenders found to
      pose a moderate risk of re-offense (tier 2 offenders). The registry
      excludes any information about offenders determined to present a low risk
      of re-offense (tier 1 offenders). Offenses include: aggravated sexual
      assault; sexual assault; aggravated criminal sexual contact; endangering
      the welfare of a child by engaging in sexual conduct which would impair or
      debauch the morals of the child; luring or enticing and, if the victim
      were a minor and the offender not a parent, kidnapping; criminal restraint
      and false imprisonment. Data includes over 1200 photos. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">
      P.R.I.O.R.S. <br />
    </p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from NJ, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">New Mexico</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
    </p>
    <p>
      <br />
    </p>
    <p className="coverage-content-sub-title">New Mexico Dept of Corrections</p>
    <p>
      Information on over 14,000 offenders who are incarcerated or on probation
      and/or parole supervision. The type of information available is an
      offenders offense, disposition, sentence, and case number.
      <br />
    </p>
    <p className="coverage-content-sub-title">New Mexico Sex Offender</p>
    <p>
      Registry contains information on individuals convicted of certain sex
      offenses on or after July 1, 1995. Also included are individuals convicted
      of a sex offense prior to that date and were incarcerated or on
      probation/parole as of that date. Data can include offender name, offender
      address, offense, conviction date, registration date and photo. Updated
      Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from NM, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">New York</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">New York Dept of Corrections</p>
    <p>
      Corrections records of statewide felony convictions of persons
      incarcerated in one of 70 state facilities and who have been released
      since Jan. 1, 1990. Records on approximately 400,000 persons. Records
      updated quarterly. Results may include defendant name, DOB, race, sex,
      offense description, case #, county of offense, sentence and sentence
      date. Records updated quarterly.
      <br />
    </p>
    <p className="coverage-content-sub-title">New York Sex Offender</p>
    <p>
      The New York Sex Offender Registry contains information on sex offenders
      classified according to their risk of re-offending: low-risk (Level 1),
      moderate-risk (Level 2) and high-risk (Level 3). This information is on
      those registered Level 3 sex offenders who committed their crimes after
      January 21, 1996. Data is collected from the registration agency, which
      may be a court, a State or local correctional facility or a probation or
      parole agency, or from the sex offender directly. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from NY, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">North Carolina</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">
      North Carolina Admin Office of Courts
    </p>
    <p>
      Court records of statewide felony, misdemeanor, traffic filings, and
      disposition records from all counties, district and superior courts since
      1973. Contains records on more than 10 million individuals. Results may
      include offense, offense class, statute, disposition, disposition date,
      degree of offense, plea, and costs/fines. Updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">
      North Carolina Dept of Corrections
    </p>
    <p>
      This database contains statewide current and historical felony information
      along with parole information for individuals that are or have been under
      the supervision of the North Carolina Department of Corrections. There is
      also misdemeanor information when 90 day plus sentencing occurred. This
      jurisdiction provides monthly updates of the most current data available.
      <br />
    </p>
    <p className="coverage-content-sub-title">North Carolina Sex Offender</p>
    <p>
      Registry contains information on nearly 9,000 individuals dating to 1996.
      Data may contain name, DOB, address, offense, statute, county, probation,
      confinement and registration date. Photos included.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from NC, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">North Dakota</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">North Dakota Admin of Courts</p>
    <p>
      Court records of statewide felony and misdemeanor dispositions from county
      district courts since 1990. Contains records on more than 137,000 persons.
      Results may include defendant name, DOB, file date, offense date, offense
      description, disposition, disposition date, case #, county of disposition.
      Updates are on HOLD from the state. Current thru October 2002.
      <br />
    </p>
    <p className="coverage-content-sub-title">North Dakota Sex Offender</p>
    <p>
      North Dakota Sex Offender Registry includes offenders identified as
      lifetime registrants or have been designated as high-risk offenders. Data
      includes name, DOB, address, offense, disposition, address verification
      data, expiration date, and photo date. Photos included.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S. </p>
    <p>
      <br /> Public Record Indexes of Record Searches. This database is
      comprised of proprietary criminal data compiled from previously ordered
      county, statewide and federal criminal requests, from ND, which contained
      records.
    </p>
    <p className="long-line">
      <br />
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Oklahoma</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">Beckham County</p>
    <p>
      District Court felony and misdemeanor public records from Beckham County
      in Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Sayre, Texola, Mayfield, Carter, Elk City and
      Erick.
      <br />
    </p>
    <p className="coverage-content-sub-title">Blaine County</p>
    <p>
      District Court felony and misdemeanor public records from Blaine County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Okeene, Watonga, Southard, Hitchcock, Hydro
      (part), Longdale, Canton, Geary (part) and Greenfield.
      <br />
    </p>
    <p className="coverage-content-sub-title">Bryan County</p>
    <p>
      District Court felony and misdemeanor public records from Bryan County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Platter, Wade, Yarnaby, Silo, Albany,
      Cartwright, Kemp, Kenefic, Mead, Colbert, Durant, Hendrix, Bokchito,
      Caddo, Calera, Achille, Armstrong and Bennington.
      <br />
    </p>
    <p className="coverage-content-sub-title">Caddo County</p>
    <p>
      District Court felony and misdemeanor public records from Caddo County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Lookeba, Albert, Washita, Gracemont, Hinton,
      Hydro (part), Cyril, Eakly, Fort Cobb, Bridgeport, Carnegie, Cement,
      Anadarko, Apache and Binger.
      <br />
    </p>
    <p className="coverage-content-sub-title">Canadian County</p>
    <p>
      Data from the Oklahoma State Courts Network with over 13000 Felony and
      Misdemeanor records dating back to 1993. Updated Monthly.
    </p>
    <p>
      Cities in this county are: Concho, Piedmont (part), Union City, Yukon,
      Mustang, Okarche (part), Oklahoma City (part), Calumet, El Reno, and Geary
      (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Carter County</p>
    <p>
      District Court felony and misdemeanor public records from Carter County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Pooleville, Rubottom, Tussy, Fox, Graham, Milo,
      Springer, Tatums, Wilson, Healdton, Lone Grove, Ratliff City, Ardmore,
      Dickson and Gene Autry.
      <br />
    </p>
    <p className="coverage-content-sub-title">Cherokee County</p>
    <p>
      District Court felony and misdemeanor public records from Cherokee County
      in Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Peggs, Welling, Cookson, Moodys, Park Hill,
      Hulbert, Oaks (part) and Tahlequah.
      <br />
    </p>
    <p className="coverage-content-sub-title">Cleveland County</p>
    <p>
      Data from the Oklahoma State Courts Network with over 52,000 Felony and
      Misdemeanor records dating back to 1989. Updated Monthly.
    </p>
    <p>
      Cities in this county are: Oklahoma City (part), Purcell (part),
      Slaughterville, Moore, Noble, Norman, Etowah, Hall Park, and Lexington.
      <br />
    </p>
    <p className="coverage-content-sub-title">Comanche County</p>
    <p>
      Data from the Oklahoma State Courts Network with over 29,000 Felony and
      Misdemeanor records dating back to 1988. Updated Monthly.
    </p>
    <p>
      Cities in this county are: Sterling, Fort Sill, Meers, Indiahoma, Lawton,
      Medicine Park, Faxon, Fletcher, Geronimo, Cache, Chattanooga (part), and
      Elgin.
      <br />
    </p>
    <p className="coverage-content-sub-title">Cotton County</p>
    <p>
      District Court felony and misdemeanor public records from Cotton County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Walters, Devol, Randlett and Temple.
      <br />
    </p>
    <p className="coverage-content-sub-title">Craig County</p>
    <p>
      District Court felony and misdemeanor public records from Craig County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Pensacola, White Oak, Vinita, Welch, Centralia,
      Big Cabin, Bluejacket and Ketchum.
      <br />
    </p>
    <p className="coverage-content-sub-title">Creek County</p>
    <p>
      District Court felony and misdemeanor public records from Creek County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Stroud (part), Milfay, Tulsa, Sapulpa,
      Shamrock, Slick, Mannford (part), Mounds, Oilton, Kellyville, Kiefer,
      Lawrence Creek, Bristow, Depew and Drumright (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Custer County</p>
    <p>
      District Court felony and misdemeanor public records from Custer County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Weatherford, Custer City, Hammon (part),
      Thomas, Arapaho, Butler and Clinton (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Delaware County</p>
    <p>
      District Court felony and misdemeanor public records from Delaware County
      in Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: West Siloam Springs, Eucha, Twin Oaks, Jay,
      Kansas, Oaks (part), Bernice, Colcord and Grove.
      <br />
    </p>
    <p className="coverage-content-sub-title">Garfield County</p>
    <p>
      Data from the Oklahoma State Courts Network with over 15,000 Felony and
      Misdemeanor records dating back to 1989. Updated Monthly.
    </p>
    <p>
      Cities in this county are: Vance Air Force Base, North Enid, Waukomis,
      Bison, Hunter, Kremlin, Lahoma, Fairmont, Garber, Hillsdale, Douglas,
      Drummond, Enid, Breckenridge, Carrier, and Covington.
      <br />
    </p>
    <p className="coverage-content-sub-title">Garvin County</p>
    <p>
      District Court felony and misdemeanor public records from Garvin County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Pernell, Stratford, Wynnewood, Hennepin,
      Maysville, Paoli, Pauls Valley, Davis (part), Elmore City and Lindsay.
      <br />
    </p>
    <p className="coverage-content-sub-title">Grant County</p>
    <p>
      District Court felony and misdemeanor public records from Grant County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Pond Creek, Renfrow, Wakita, Manchester,
      Medford, Nash, Deer Creek, Jefferson and Lamont.
      <br />
    </p>
    <p className="coverage-content-sub-title">Haskell County</p>
    <p>
      District Court felony and misdemeanor public records from Haskell County
      in Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Hoyt, Lequire, Stigler, Tamaha, Whitefield,
      Keota, Kinta and McCurtain.
      <br />
    </p>
    <p className="coverage-content-sub-title">Hughes County</p>
    <p>
      District Court felony and misdemeanor public records from Hughes County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Atwood, Stuart, Wetumka, Yeager, Gerty,
      Holdenville, Lamar, Allen (part), Calvin and Dustin.
      <br />
    </p>
    <p className="coverage-content-sub-title">Kay County</p>
    <p>
      District Court felony and misdemeanor public records from Kay County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Peckham, Tonkawa, Kaw, Nardin, Kildare,
      Newkirk, Ponca City (part), Blackwell, Braman and Kaw City.
      <br />
    </p>
    <p className="coverage-content-sub-title">Kingfisher County</p>
    <p>
      District Court felony and misdemeanor public records from Kingfisher
      County in Oklahoma. Data may contain offender name, birth date, offense,
      case number, and file date.
    </p>
    <p>
      Cities in this county are: Piedmont (part), Omega, Kingfisher, Loyal,
      Okarche (part), Cashion (part), Dover and Hennessey.
      <br />
    </p>
    <p className="coverage-content-sub-title">Murray County</p>
    <p>
      District Court felony and misdemeanor public records from Murray County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Sulphur, Davis (part), Dougherty and Hickory.
      <br />
    </p>
    <p className="coverage-content-sub-title">Lincoln County</p>
    <p>
      District Court felony and misdemeanor public records from Lincoln County
      in Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Wellston, Stroud (part), Tryon, Warwick,
      Meeker, Prague, Sparks, Davenport, Fallis, Kendrick, Agra, Carney and
      Chandler.
      <br />
    </p>
    <p className="coverage-content-sub-title">Logan County</p>
    <p>
      Data Pulled from the Oklahoma State Courts Network with over 1,000 Felony
      and Misdemeanor records dating back to 1990. Updated monthly.
    </p>
    <p>
      Cities in this county are: Mulhall, Orlando, Langston, Marshall, Meridian,
      Coyle, Crescent, Guthrie, Cashion (part), Cedar Valley, and Cimarron City.
      <br />
    </p>
    <p className="coverage-content-sub-title">Mayes County</p>
    <p>
      District Court felony and misdemeanor public records from Mayes County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Pryor, Rose, Strang, Ketchum, Mazie, Salina,
      Spavinaw, Sportsmen Acres, Locust Grove, Pensacola, Pryor Creek, Grand
      Lake Towne, Hoot Owl, Langley, Adair, Chouteau and Disney.
      <br />
    </p>
    <p className="coverage-content-sub-title">McClain County</p>
    <p>
      District Court felony and misdemeanor public records from McClain County
      in Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Washington, Wayne, Oklahoma City (part),
      Purcell (part), Rosedale, Dibble, Goldsby, Newcastle, Blanchard (part),
      Byars and Cole.
      <br />
    </p>
    <p className="coverage-content-sub-title">Muskogee County</p>
    <p>
      District Court felony and misdemeanor public records from Muskogee County
      in Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Webbers Falls, Taft, Wainwright, Warner,
      Oktaha, Porum, Summit, Fort Gibson, Haskell, Muskogee, Boynton, Braggs and
      Council Hill.
      <br />
    </p>
    <p className="coverage-content-sub-title">Noble County</p>
    <p>
      District Court felony and misdemeanor public records from Noble County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Perry, Red Rock, Lucien, Billings, Marland and
      Morrison.
      <br />
    </p>
    <p className="coverage-content-sub-title">Oklahoma County</p>
    <p>
      Data from the Oklahoma State Courts Network with over 147,000 Felony and
      Misdemeanor records dating back to 1988. Updated Monthly.
    </p>
    <p>
      Cities in this county are: Newalla, Tinker Air Force Base, Wheatland,
      Warr, Acres, Woodlawn Park, Moore, Spencer, The Village, Valley Brook,
      Nicoma Park, Oklahoma City (part), Smith Village, Luther, Midwest City,
      Nichols Hills, Harrah, Jones, Lake Aluma, Del City, Edmond, Forest Park,
      Arcadia, Bethany, and Choctaw.
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Oklahoma Criminal Justice Resource Center
    </p>
    <p>
      Data is provided by the Oklahoma Criminal Justice Resource Center. Data
      contains felony convictions from each of the state&rsquo;s 77 county
      courts, since 1999.This file is ONLY available on a quarterly basis and is
      current thru March 2004. Annually, there are 30,000 felony convictions
      tied to 18,000 people. It contains all types of sentences &ndash;
      probation, jail or prison &ndash; with the exception of misdemeanors and
      deferred judgments. The counties e-mail or mail copies of each Judgment
      &amp; Sentence document to OCJRC, where employees note essential
      information and enter elements into a database.
      <br />
    </p>
    <p className="coverage-content-sub-title">Oklahoma Dept of Corrections</p>
    <p>
      Current and historical Corrections records on persons who are or have been
      under the supervision of the Oklahoma Department of Corrections. More than
      194,000 records, most from cases file after 1997. Results may include
      name, date of birth, court, case, offense. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Oklahoma Sex Offender</p>
    <p>
      The Oklahoma Sex Offender Registry provides public information on all
      registered aggravated and habitual sex offenders, including photos.
      Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Osage County</p>
    <p>
      District Court felony and misdemeanor public records from Osage County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Bowring, Tulsa (part), Webb City, Wynona, Sand
      Springs (part), Shidler, Skiatook (part), Pawhuska, Ponca City (part),
      Prue, Grainola, Hominy, Osage, Burbank, Fairfax, Foraker, Avant, Barnsdall
      and Bartlesville (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Ottawa County</p>
    <p>
      District Court felony and misdemeanor public records from Ottawa County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Monkey Island, Wyandotte, Bernice, Cleora,
      Peoria, Picher, Quapaw, Fairland, Miami, North Miami, Afton, Cardin and
      Commerce.
      <br />
    </p>
    <p className="coverage-content-sub-title">Pawnee County</p>
    <p>
      District Court felony and misdemeanor public records from Pawnee County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Terlton, Westport, Ralston, Shady Grove,
      Skedee, Maramec, Pawnee, Quay (part), Jennings, Lone Chimney, Mannford
      (part), Blackburn, Cleveland and Hallett.
      <br />
    </p>
    <p className="coverage-content-sub-title">Payne County</p>
    <p>
      Data from the Oklahoma State Courts Network with over 14,000 Felony and
      Misdemeanor records dating back to 1994. Updated Monthly.
    </p>
    <p>
      Cities in this county are: Stillwater, Yale, Perkins, Quay (part), Ripley,
      Cushing, Drumright (part), and Glencoe.
      <br />
    </p>
    <p className="coverage-content-sub-title">Pottawatomie County</p>
    <p>
      District Court felony and misdemeanor public records from Pottawatomie
      County in Oklahoma. Data may contain offender name, birth date, offense,
      case number, and file date.
    </p>
    <p>
      Cities in this county are: Dale, Tecumseh, Tribbey, Wanette, Pink,
      Shawnee, Saint Louis, Maud (part), McLoud, Oklahoma City (part),
      Earlsboro, Johnson, Macomb, Asher, Bethel Acres and Brooksville.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from OK, which contained records.
      Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Rogers County</p>
    <p>
      Data from the Oklahoma State Courts Network with over 7,000 Felony and
      Misdemeanor records dating back to 1997. Updated Monthly.
    </p>
    <p>
      Cities in this county are: Valley Park, Oologah, Owasso (part), Talala,
      Tulsa (part), Inola, Jamestown, Oolagah (Oologah), Collinsville (part),
      Fair Oaks (part), Foyil, Catoosa (part), Chelsea, and Claremore.
      <br />
    </p>
    <p className="coverage-content-sub-title">Seminole County</p>
    <p>
      District Court felony and misdemeanor public records from Seminole County
      in Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Seminole, Wewoka, New Lima, Lima, Maud (part),
      Sasakwa, Bowlegs, Cromwell and Konawa.
      <br />
    </p>
    <p className="coverage-content-sub-title">Sequoyah County</p>
    <p>
      District Court felony and misdemeanor public records from Sequoyah County
      in Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Roland, Sallisaw, Vian, Moffett, Muldrow,
      Paradise Hill, Gans, Gore and Marble City.
      <br />
    </p>
    <p className="coverage-content-sub-title">Stephens County</p>
    <p>
      District Court felony and misdemeanor public records from Stephens County
      in Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Foster, Marlow, Velma, Countyline, Duncan,
      Empire City, Loco, Bray, Central High and Comanche.
      <br />
    </p>
    <p className="coverage-content-sub-title">Texas County</p>
    <p>
      District Court felony and misdemeanor public records from Texas County in
      Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Tyrone, Adams, Hooker, Optima, Texhoma,
      Goodwell, Guymon and Hardesty.
      <br />
    </p>
    <p className="coverage-content-sub-title">Tulsa County</p>
    <p>
      Data from the Oklahoma State Courts Network with over 125,000 Felony and
      Misdemeanor records dating back to 1988. Updated Monthly.
    </p>
    <p>
      Cities in this county are: Tulsa (part), Leonard, Oakhurst, Sand Springs
      (part), Skiatook (part), Sperry, Lotsee, Mannford (part), Owasso (part),
      Glenpool, Jenks, Liberty (part), Bixby (part), Broken Arrow (part), and
      Collinsville (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Wagoner County</p>
    <p>
      District Court felony and misdemeanor public records from Wagoner County
      in Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Tullahassee, Wagoner, Okay, Porter, Redbird,
      Coweta, Fair Oaks (part), New Tulsa, Bixby (part), Broken Arrow (part) and
      Catoosa (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Washington County</p>
    <p>
      District Court felony and misdemeanor public records from Washington
      County in Oklahoma. Data may contain offender name, birth date, offense,
      case number, and file date.
    </p>
    <p>
      Cities in this county are: Ochelata, Ramona, Vera, Bartlesville (part),
      Copan and Dewey.
      <br />
    </p>
    <p className="coverage-content-sub-title">Washita County</p>
    <p>
      District Court felony and misdemeanor public records from Washita County
      in Oklahoma. Data may contain offender name, birth date, offense, case
      number, and file date.
    </p>
    <p>
      Cities in this county are: Rocky, Sentinel, Cordell, Dill City, Foss, New
      Cordell, Clinton (part), Colony, Corn, Bessie, Burns Flat and Canute.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Ohio</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">Butler County</p>
    <p>
      Butler County data contains criminal records on over 20,000 individuals
      dating back to 1971. Results may include Offense, Degree of Offense,
      Disposition information, Case Number, Arrest Date and File Date. Updated
      Monthly.
    </p>
    <p>
      Cities in this county are: Rossville, Shandon, West Chester, Miami
      University, Okeana, Overpeck, Wayne Township, Collinsville, Lindenwald,
      Saint Clair, Township, Trenton, Union Township, Seven Mile (part),
      Sharonville (part), Somerville, Oxford Township, Reily Township, Ross
      Township, Monroe (part), Morgan Township, New Miami, Middletown (part),
      Milford Township, Millville (part), Lemon Township, Liberty Township,
      Madison Township, Hanover Township, Indian Springs, Jacksonburg, College
      Corner (part), Fairfield (part), and Hamilton.
      <br />
    </p>
    <p className="coverage-content-sub-title">Columbiana County</p>
    <p>
      Columbiana County Common Pleas Court data contains criminal records on
      over 3,600 individuals dating back to 1972. Data can contain Offense, Case
      Number, Disposition, Disposition Date, Status, and File Date.
    </p>
    <p>
      Cities in this county are: Winona, Negley, North Georgetown, West Point,
      Elkton, Homeworth, Kensington, Yellow Creek Township, Calcutta, East
      Rochester, Wayne Township, Wellsville, West Township, Unity Township,
      Washington Township, Washingtonville (part), Salineville (part), Saint
      Clair Township, Summitville, Perry Township, Rogers, Salem, Middleton
      Township, Minerva (part), New Waterford, Lisbon, Liverpool Township,
      Madison Township, Hanoverton, Knox Township, Leetonia (part), Fairfield
      Township, Franklin Township, Hanover Township, East Liverpool, East
      Palestine, Elkrun Township, Butler Township, Center Township, and
      Columbiana (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Franklin County</p>
    <p>
      Franklin County Municipal Court data contains criminal records on over
      372,000 individuals. Data can contain Offense, Case Number, Disposition,
      Jurisdiction, Status, and File Date. Data is limited to cases where
      offender has a date of birth on record.
    </p>
    <p>
      Cities in this county are: Galloway, Lincoln Village Fin Unit,
      Worthington, Amlin, Blacklick, Washington Township, Westerville (part),
      Whitehall, Upper Arlington, Urbancrest, Valleyview, Riverlea, Sharon
      Township, Truro Township, Pleasant Township, Prairie Township,
      Reynoldsburg (part), Perry Township, Pickerington (part), Plain Township,
      New Rome, Norwich Township, Obetz (part), Mifflin Township, Minerva Park,
      New Albany, Lockbourne, Madison Township, Marble Cliff, Hilliard (part),
      Jackson Township, Jefferson Township, Groveport, Hamilton Township,
      Harrisburg (part), Gahanna, Grandview Heights, Grove City, Columbus
      (part), Dublin (part), Franklin Township, Brown Township, Canal Winchester
      (part), Clinton Township, Bexley, Blendon Township, and Brice.
      <br />
    </p>
    <p className="coverage-content-sub-title">Greene County</p>
    <p>
      Greene County data kept by the Clerk of Courts contains criminal records
      on over 12,000 individuals dating back to 1980. Data can contain Offense,
      Disposition, Disposition Date, and Status.
    </p>
    <p>
      Cities in this county are: Wilberforce, Yellow Springs, Alpha, Dayton,
      Spring Valley Township, Sugar Creek Township, Xenia, New Jasper Township,
      Ross Township, Silver Creek Township, Jefferson Township, Kettering
      (part), Miami Township, Clifton (part), Fairborn (part), Jamestown,
      Bowersville, Caesars Creek Township, Cedarville Township, Bath Township,
      Beavercreek, and Bellbrook.
      <br />
    </p>
    <p className="coverage-content-sub-title">Hamilton County</p>
    <p>
      Hamilton County data contains criminal records on over 58,000 individuals
      dating back to 1973. Data can contain Offense, Degree of Offense,
      Disposition, Case Number, and File Date.
    </p>
    <p>
      Cities in this county are: Western Hills, Westwood, Roselawn Finance,
      Sayler Park, Taft, Mount Saint Joseph, Parkdale, Queen City, Groesbeck,
      Hooven, Miamitown, Wyoming, Camp Dennison, College Hill, The Village of
      Indian Hill, Whitewater Township, Woodlawn, Sycamore Township, Symmes
      Township, Terrace Park, Springdale, Springfield Township, Saint Bernard,
      Reading, Sharonville (part), Silverton, North Bend, North College Hill,
      Norwood, Montgomery, Mount Healthy, Newtown, Mariemont, Miami Township,
      Milford (part), Lockland, Loveland (part), Madeira, Greenhills, Harrison,
      Lincoln Heights, Glendale, Golf Manor, Green Township, Fairfax, Fairfield
      (part), Forest Park, Delhi Township, Elmwood Place, Evendale, Columbia
      Township, Crosby Township, Deer Park, Cincinnati, Cleves (part), Colerain
      Township, Arlington Heights, Blue Ash, Cheviot, Addyston, Amberley, and
      Anderson Township.
      <br />
    </p>
    <p className="coverage-content-sub-title">Montgomery County</p>
    <p>
      Montgomery County data contains criminal records on nearly 40,000
      individuals dating back to 1990. Data can contain Offense, Degree of
      Offense, Disposition, Case Number, and File Date. Updated Monthly.
    </p>
    <p>
      Cities in this county are: Wright Patterson AFB, West Carrollton,
      Washington, Township, Wayne Township, West Carrollton City, Union,
      Vandalia, Verona (part), Riverside City Township, Springboro (part),
      Trotwood, Phillipsburg, Randolph Township, Riverside, New Lebanon (part),
      Oakwood, Perry Township, Miami Township, Miamisburg, Moraine, Kettering
      (part), Mad River Township, Madison Township, Huber Heights (part),
      Jackson Township, Jefferson Township, German Township, Germantown,
      Harrison Township, Dayton, Englewood, Farmersville, Centerville, Clay
      Township, Clayton (part), Brookville (part), Butler Township, and Carlisle
      (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Ohio Dept of Corrections</p>
    <p>
      Corrections records of statewide felony convictions of persons
      incarcerated in a state facility since Jan. 1, 1990. Records on
      approximately 377,000 persons. Records updated monthly. Results may
      include defendant name, DOB, race, sex, offense description, case #,
      county of offense, sentence and sentence date. Records updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Ohio Supplemental Dept of Corrections
    </p>
    <p>
      This source contains data on sex offenses and Ohio Department of
      Corrections. There are nearly 400,000 criminal records, which includes
      over 9,000 individual sex offenders. Results may include Offense, Sentence
      Information, Institution, Arrest Date, and Next Parole Date. Also included
      are over 150,000 photos.Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Ohio Sex Offender</p>
    <p>
      Ohio Sex Offender Records. Data can contain offense, address, county,
      local school district, and photo.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from OH, which contained records.
      <br />
    </p>
    <p className="coverage-content-sub-title">Summit County</p>
    <p>
      Summit County data contains over 300,000 criminal records dating back to
      the early 1900s. Results may include Offense, Degree of Offense, Statute,
      Case Number, and File Date.Updated Monthly.
    </p>
    <p>
      Cities in this county are: Uniontown, Tallmadge, Twinsburg Township,
      Hudson, Silver Lake, Springfield Township, Stow, Reminderville, Richfield
      Township, Sagamore Hills Township, Northfield, Norton (part), Peninsula,
      Mogadore (part), Munroe Falls, Northfield Center Township, Hudson Village,
      Lakemore, Macedonia, Fairlawn, Franklin Township, Green, Copley Township,
      Coventry Township, Cuyahoga Falls, Boston Heights, Boston Township,
      Clinton, Akron, Barberton, and Bath Township.
      <br />
    </p>
    <p className="coverage-content-sub-title">Warren County</p>
    <p>
      Warren County Common Pleas Court data contains criminal records on over
      6,000 individuals dating back to 1991. Data can contain Offense, Case
      Number, Disposition, Disposition Date, Status, and File Date.
    </p>
    <p>
      Cities in this county are: Kings Mills, Oregonia, Otterbien Home,
      Washington Township, Wayne Township, Waynesville, Springboro (part),
      Turtle Creek Township, Union Township, Pleasant Plain, Salem Township,
      South Lebanon (part), Middletown (part), Monroe (part), Morrow,
      Maineville, Mason (part), Massie Township, Harveysburg, Lebanon, Loveland
      (part), Franklin, Hamilton Township, Harlan Township, Clear Creek
      Township, Corwin, Deerfield Township, Blanchester (part), Butlerville, and
      Carlisle (part).
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Oregon</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">Oregon Admin of Courts</p>
    <p>
      This database contains current and historical felony and misdemeanor
      records of individuals who are or have been under the jurisdiction of the
      Oregon Court system, which includes traffic violations. There are records
      on approximately 4,500,000 persons. Results may include name, DOB,
      offense, case number, case type, file date, incident date, sentence date,
      and status. Updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Oregon Dept of Corrections</p>
    <p>
      Corrections records on persons sentenced to serve time in a state
      institution since 1987. Records on approximately 290,000 persons. Results
      may include defendant name, DOB, offense, degree of offense, case number,
      sentence date, release date, and status. Records updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Oregon Sex Offender</p>
    <p>
      Contains information on convicted sex offenders. Data may contain offender
      name, date of birth, county, and data last updated.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from OR, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Pennsylvania</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
    </p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Pennsylvania Admin Office of Courts
    </p>
    <p>
      Statewide District Court Criminal Filings from the state of PA, excluding
      Pittsburgh Magistrates Court, and Philadelphia City Court since 1995. This
      is a name only search. The Date of Birth is NOT provided from this source.
      Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Pennsylvania Dept of Corrections
    </p>
    <p>
      Corrections records of statewide records of currently under the
      Department&apos;s supervision. Records on approximately 47,000 persons.
      Results may show defendant name, race, offense description, county, and
      current location. The Date of Birth is NOT provided from this source.
      <br />
    </p>
    <p className="coverage-content-sub-title">Pennsylvania Sex Offender</p>
    <p>
      Registry contains data on individuals that have been sentenced as a sex
      offender or a sexually violent predator. Registry does not include all
      individuals convicted of a sex crime. Data may include name, date of
      birth, address, offense, statute, and police agency.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from PA, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">South Carolina</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected. <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">
      South Carolina Dept of Corrections
    </p>
    <p>
      Corrections records of South Carolina statewide felony and gross
      misdemeanor records on persons found guilty and sentenced to serve time
      and/or subsequent probation in a state penal institution. Includes
      probation and parole information where applicable. Records on
      approximately 202,000 persons dating to 1986. Results may include
      defendant name, DOB, race, sex, offense date, offense description,
      disposition, disposition date, case #, county of disposition, sentence.
      Records updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">South Carolina Sex Offender</p>
    <p>
      Registry contains information on sex offenders who have been convicted,
      pled guilty or nolo contendere. Data can include offender name, offender
      date of birth, offender address, offense, statute, and photo. Updated
      Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from SC, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Rhode Island</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected. <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Rhode Island Admin Office of Courts
    </p>
    <p>
      Superior and District Court records of statewide felony and misdemeanor
      cases disposed since 1984. Records on over 300,000 persons. Results may
      include case number, name, DOB, sex, address, offense, offense location,
      file date, disposition, disposition date, sentence, sentence type and
      sentence date. Updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from RI, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">South Dakota</p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
    </p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-sub-title">South Dakota Sex Offender</p>
    <p>
      Contains information on convicted sex offenders including photographs.
      Data may contain offender name, date of birth, offense, county, and
      conviction date.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from SD, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Tennessee</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Tennessee Admin Office of Courts
    </p>
    <p>
      Court records of statewide felony and misdemeanor convictions from all 95
      counties since 1990. Approximately 900,000 records. Results may include
      the date, county, case #, defendant name &amp; aliases (when available),
      DOB, social security number (when available), charges,
      dispositions/judgements and sentence. Records updated monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Tennessee AOC - Supplemental</p>
    <p>
      Data contains misdemeanor, traffic, and infraction records dating back to
      1990. Results may include name, offense, degree of offense, type of
      filing, file date, disposition date, and judgement type.
      <br />
    </p>
    <p className="coverage-content-sub-title">Tennessee Dept of Corrections</p>
    <p>
      Contains current and historical statewide felony and misdemeanor
      information for inmates, probationers and parolees who are or have been
      under the supervision of the Tennessee Department of Corrections. The
      jurisdiction provides annual updates.
      <br />
    </p>
    <p className="coverage-content-sub-title">Tennessee Sex Offender</p>
    <p>
      Tennessee Sexual Offender Registry information about sex offenders who
      committed certain enumerated offenses on or after July 1, 1997. Photos
      included. Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from TN, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Texas</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Bexar County</p>
    <p>
      Data provided by Bexar County District Court Clerk. Contains felony and
      misdemeanor records dating back to 1974.
    </p>
    <p>
      Cities in this county are: Wetmore, Macdona, Von Ormy, Fair Oaks,
      Atascosa, Boerne, Universal City, Windcrest, Adkins, Somerset, Saint
      Hedwig, Terrell Hills, Schertz (part), Selma (part), Shavano Park, Lytle
      (part), Olmos Park, San Antonio, Kirby, Leon Valley, Live Oak, Helotes,
      Hill Country Village, Hollywood Park, Elmendorf, Fair Oaks Ranch (part),
      Grey Forest, China Grove, Cibolo (part), Converse, Alamo Heights, Balcones
      Heights, and Castle Hills.
      <br />
    </p>
    <p className="coverage-content-sub-title">Chambers County</p>
    <p>
      Data provided by Chambers County. Data may contain name, offense, file
      date and disposition date. There are no Dates of Birth.
    </p>
    <p>
      Cities in this county are: Winnie, Monroe City, Stowell, Wallisville,
      Seabrook (part), Shoreacres (part), Hankamer, Cove, Mont Belvieu (part),
      Old River-Winfree, Anahuac, Baytown (part) and Beach City.
      <br />
    </p>
    <p className="coverage-content-sub-title">Collin County</p>
    <p>
      Data provided by Collin County. Contains over 125,000 felony and
      misdemeanor records. Data may contain name, DOB, address, offense, degree
      of offense, offense date, case number, plea, disposition, disposition
      date, fine, court cost, court, sentence date, jail time, probation, judge,
      attorney, and file date.
    </p>
    <p>
      Cities in this county are: Copeville, Westminster, Weston, Wylie (part),
      Royse City (part), Sachse (part), Saint Paul, Princeton, Prosper,
      Richardson (part), New Hope, Parker, Plano (part), Melissa, Murphy,
      Nevada, Lowry Crossing, Lucas, McKinney, Garland (part), Josephine (part),
      Lavon, Fairview, Farmersville, Frisco (part), Carrollton (part), Celina,
      Dallas (part), Allen, Anna, and Blue Ridge.
      <br />
    </p>
    <p className="coverage-content-sub-title">Comal County</p>
    <p>
      Data provided by Comal County. Data contains felony and misdemeanor
      information on over 60,000 individuals dating back to 1980. Data may
      contain name, DOB, offense, offense date, degree of offense, disposition,
      cause number, fine, court costs, and file date.
    </p>
    <p>
      Cities in this county are: Spring Branch, Canyon Lake, Fischer, San
      Antonio, Schertz (part), Selma (part), Bulverde, Fair Oaks Ranch (part),
      Garden Ridge, and New Braunfels (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Dallas County</p>
    <p>
      Data provided by the Dallas County Data Services division. Contains felony
      and misdemeanor records dating back to the early 1980s. Arrest data is
      also included in this database.
    </p>
    <p>
      Cities in this county are: Wylie (part), Sunnyvale, University Park,
      Wilmer, Rowlett (part), Sachse (part), Seagoville (part), Mesquite, Ovilla
      (part), Richardson (part), Irving, Lancaster, Lewisville (part), Grand
      Prairie (part), Highland Park, Hutchins, Flower Mound (part), Garland
      (part), Glenn Heights (part), DeSoto, Duncanville, Farmers Branch, Combine
      (part), Coppell (part), Dallas (part), Carrollton (part), Cedar Hill
      (part), Cockrell Hill, Addison, Balch Springs, and Buckingham.
      <br />
    </p>
    <p className="coverage-content-sub-title">Denton County</p>
    <p>
      Data provided by Denton County Department of Information Services.
      Contains felony and misdemeanor records dating back to 1990.
    </p>
    <p>
      Cities in this county are: The Colony, Trophy Club (part), Westlake
      (part), Sanger, Shady Shores, Southlake (part), Plano (part), Ponder,
      Roanoke, Northlake, Oak Point, Pilot Point, Lincoln Park, Little Elm,
      Marshall Creek, Lake Dallas, Lakewood Village, Lewisville (part), Justin,
      Krugerville, Krum, Hebron, Hickory Creek, Highland Village, Grapevine
      (part), Hackberry, Haslet (part), Flower Mound (part), Fort Worth (part),
      Frisco (part), Dallas (part), Denton, Double Oak, Corinth, Corral City,
      Cross Roads, Carrollton (part), Coppell (part), Copper Canyon, Argyle,
      Aubrey, and Bartonville.
      <br />
    </p>
    <p className="coverage-content-sub-title">El Paso County</p>
    <p>
      County Court records on persons who have been convicted of felonies ONLY
      since 1994. Results may include defendant name, case #, disposition,
      sentence date.
    </p>
    <p>
      Cities in this county are: Fort Bliss, San Elizario, Tornillo, Biggs
      Field, Canutillo, Fabens, Horizon City, Socorro, Vinton, Anthony, Clint,
      and El Paso.
      <br />
    </p>
    <p className="coverage-content-sub-title">Ft. Bend County</p>
    <p>
      Felony records from Ft. Bend County on over 36,000 offenders. Contains
      records dating back to 1982. Data may contain offense, disposition date,
      sentence, fine, and case number. Updated monthly.
    </p>
    <p>
      Cities in this county are: Meadows Place, Clodine, Fresno, Guy, Sugar
      Land, Thompsons, Booth, Rosenberg, Simonton, Stafford (part), Orchard,
      Pleak, Richmond, Meadows, Missouri City (part), Needville, Houston (part),
      Katy (part), Kendleton, Arcola, Beasley, and Fulshear.
      <br />
    </p>
    <p className="coverage-content-sub-title">Grayson County</p>
    <p>
      Data provided by Grayson County. Contains misdemeanor records dating back
      to 1983 and felony records dating back to 1983.
    </p>
    <p>
      Cities in this county are: Whitewright (part), Gordonville, Tom Bean, Van
      Alstyne, Whitesboro, Sherman, Southmayd, Tioga, Knollwood, Pottsboro,
      Sadler, Dorchester, Gunter, Howe, Bells, Collinsville, and Denison.
      <br />
    </p>
    <p className="coverage-content-sub-title">Gregg County</p>
    <p>
      Data provided by Gregg County. Contains misdemeanor records dating back to
      1983 and felony records dating back to 1977.
    </p>
    <p>
      Cities in this county are: Warren City (part), White Oak, Judson, Kilgore
      (part), Lakeport, Longview (part), Clarksville City (part), Easton (part),
      and Gladewater (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Harris County</p>
    <p className="coverage-content-red">*** CONVICTION DATA ONLY ***</p>
    <p>
      County Court records on persons who have been convicted of Felonies (since
      1997) and Misdemeanors. Records on approximately 135,000 persons. Results
      show defendant name, DOB, race, sex, case #, disposition, sentence,
      sentence date.
    </p>
    <p>
      Cities in this county are: Park Row, Spring, Kingwood, Klein, North
      Houston, Hockley, Huffman, Hufsmith, Crosby, Cypress, Highlands, Barker,
      Barrett, Channelview, West University Place, Alief, Atascocita, Tomball
      (part), Waller (part), Webster, Spring Valley, Stafford (part), Taylor
      Lake Village, Shoreacres (part), South Houston, Southside Place, Pearland
      (part), Piney Point Village, Seabrook (part), Morgan&apos;s Point, Nassau
      Bay, Pasadena, La Porte, League City (part), Missouri City (part), Jacinto
      City, Jersey Village, Katy (part), Houston (part), Humble, Hunters Creek
      Village, Galena Park, Hedwig Village, Hilshire Village, Deer Park, El
      Lago, Friendswood (part), Baytown (part), Bellaire, and Bunker Hill
      Village.
      <br />
    </p>
    <p className="coverage-content-sub-title">Montgomery County (Felony)</p>
    <p>
      Data provided by Montgomery County District Clerk. Contains over 25,000
      felony records dating back to 1989.
    </p>
    <p>
      Cities in this county are: Spring, The Woodlands, New Caney, Pinehurst,
      Porter, Woodloch, Dobbin, Grangerland, Tomball (part), Willis, Woodbranch,
      Shenandoah, Splendora, Stagecoach, Panorama Village, Patton Village, Roman
      Forest, Magnolia, Montgomery, Oak Ridge North, Conroe, Cut and Shoot, and
      Houston (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Montgomery County (Misd)</p>
    <p>
      Data provided by Montgomery County District Clerk. Contains over 130,000
      misdemeanor records dating back to 1970. Data may contain name, DOB,
      address, offense, degree of offense, cause number, judgment, plea,
      judgment-plea date, disposed offense, fine, court cost, court, dismiss
      date and file date.
    </p>
    <p>
      Cities in this county are: Spring, The Woodlands, New Caney, Pinehurst,
      Porter, Woodloch, Dobbin, Grangerland, Tomball (part), Willis, Woodbranch,
      Shenandoah, Splendora, Stagecoach, Panorama Village, Patton Village, Roman
      Forest, Magnolia, Montgomery, Oak Ridge North, Conroe, Cut and Shoot, and
      Houston (part).
      <br />
    </p>
    <p className="coverage-content-sub-title">Nueces County</p>
    <p>
      County Court records on persons who have been convicted of felonies and
      misdemeanors. Results may include defendant name, case #, disposition,
      sentence date.
    </p>
    <p>
      Cities in this county are: Banquete, Chapman Ranch, Port Aransas, Portland
      (part), Robstown, Corpus Christi (part), Driscoll, Petronila, Agua Dulce,
      Aransas Pass (part), and Bishop.
      <br />
    </p>
    <p className="coverage-content-sub-title">Potter County</p>
    <p>
      Data provided by Potter County. Data contains felony and misdemeanor
      information on over 82,000 individuals. Data may contain name, DOB,
      offense, degree of offense, disposition, disposition date, fine, and file
      date.
    </p>
    <p>
      Cities in this county are: Amarillo (part) and Bushland.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from TX, which contained records.
      <br />
    </p>
    <p className="coverage-content-sub-title">Texas Dept of Criminal Justice</p>
    <p>
      Data provided by the Texas Department of Corrections (TDC). Contains
      paroled convicts information on criminals who have entered the prison
      system dating back to 1979. Data may additionally include offenders
      committing felonies or misdemeanors who have been on probation or
      community supervision under the Department of criminal justice. Updated
      Monthly
      <br />
    </p>
    <p className="coverage-content-sub-title">Texas DPS</p>
    <p>
      Search of Public Record Criminal History Information relating to Felony
      and Misdemeanor Convictions or Deferred Adjudication regarding Felony
      Offenses for a minimum of 7 years. As of 01/01/2000 Deferred Adjudication
      regarding Misdemeanor offenses are included in the Public Record section
      Information returned can include Filing Date; Charge; Charge Level;
      Disposition; County; ID Information. Updated Monthly
      <br />
    </p>
    <p className="coverage-content-sub-title">Texas Sex Offender</p>
    <p>
      Data provided by the Texas Department of Public Safety. Contains over
      30,000 registered sex offenders and 27,000 photos dating back to 1951.
      Updated Monthly
      <br />
    </p>
    <p className="coverage-content-sub-title">Tom Green County</p>
    <p>
      Data provided by Tom Green. Contains misdemeanor records dating back to
      1995 and felony records dating back to 1993.
    </p>
    <p>
      Cities in this county are: Water Valley, Vancourt, Veribest, Wall,
      Goodfellow Air Force Base, Knickerbocker, Mereta, San Angelo, Carlsbad,
      and Christoval.
      <br />
    </p>
    <p className="coverage-content-sub-title">Travis County</p>
    <p>
      Data provided by Travis County Information Services. Contains misdemeanor
      records dating back to 1988 and felony records dating back to 1992.
    </p>
    <p>
      Cities in this county are: Spicewood, Del Valle, Manchaca, McNeil, Sunset
      Valley, West Lake Hills, Bee Caves, Rollingwood, Round Rock (part), San
      Leanna, Manor, Mustang Ridge (part), Pflugerville, Lago Vista, Lakeway,
      Leander (part), Cedar Park (part), Creedmoor, Jonestown, Austin (part),
      Bee Cave, and Briarcliff.
      <br />
    </p>
    <p className="coverage-content-sub-title">Victoria County</p>
    <p>
      Data provided by Victoria County. Data contains felony and misdemeanor
      information on over 8,000 individuals. Data may contain name, DOB,
      offense, disposition, disposition date, cause number, offense number, and
      file date.
    </p>
    <p>
      Cities in this county are: Raisin, Telferner, McFaddin, Nursery, Placedo,
      Victoria, Bloomington, and Inez.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Utah</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Utah Admin of Courts</p>
    <p>
      Utah Admin Office of the Courts contains all historical data from 1996
      (with some courts not coming online in Utah until 1997) to present for all
      criminal convictions. Results may include Case Number, Disposition,
      Disposition Date, File Date, Offense, Degree Of Offense, and Statute.
      Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Utah Dept. of Corrections</p>
    <p>
      Corrections records of Utah statewide felony and gross misdemeanor records
      on persons found guilty and sentenced to serve time and/or subsequent
      probation in a state penal institution. Includes probation and parole
      information where applicable. Records on approximately 200,000 persons
      dating to 1986. Results may include defendant name, DOB, race, sex,
      sentence date, offense description, disposition date, case number, county
      of disposition, sentence. Records updated quarterly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Utah Sex Offender</p>
    <p>
      Utah Sex Offender Registry of persons who have either been convicted of or
      entered a plea in abeyance to certain sex offenses. Data may include
      offense, degree of offense, conviction date and photo of individual.
      Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from UT, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Vermont</p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
    </p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from VT, which contained records.
      <br />
    </p>
    <p className="coverage-content-sub-title">Vermont Sex Offender</p>
    <p>
      Contains information on convicted sex offenders including photographs.
      Data may contain offender name, date of birth, offense, county, and
      conviction date.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Virginia</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">Virginia Courts</p>
    <p>
      This database contains statewide and/or county-level current and
      historical felony and misdemeanor dispositions, including motor vehicle
      citations of individuals who are or have been under the supervision of the
      Virginia General District or Circuit Courts since 1993. This jurisdiction
      provides monthly updates of the most current data available. NOTE: These
      records are from all Virginia counties and independent municipalities
      except: FAIRFAX--(General District and Circuit Courts) PRINCE WILLIAM--(No
      Circuit Court records) ALEXANDRIA--(No Circuit Court records).
      <br />
    </p>
    <p className="coverage-content-sub-title">Virginia Sex Offender</p>
    <p>
      Contains information on convicted sex offenders, including over 18,000
      photos. Data also includes crimes against minors. This data does not
      contain DOBs, however, the age of the offender is included.
      <br />
    </p>
    <p className="coverage-content-sub-title">Fairfax County</p>
    <p>
      Data provided by Fairfax County Clerks Office. This Data, conviction
      records only, contains Felony and Misdemeanor cases dating back to
      07/01/1979. Results may include Offense, Offense Date, Disposition,
      Disposition Date, and Degree of Offense.
    </p>
    <p>
      Cities in this county are: West Springfield, Springfield, Sully Station,
      West McLean, Pimmit, Reston, Seven Corners, North Springfield, Oak Hill,
      Oakton, Mosby, Mount Vernon, Newington, Mason Neck, McLean, Merrifield,
      Jefferson Manor, Kingstowne, Lorton, Fort Belvoir, Great Falls, Greenway,
      Engleside, Fairfax Station, Falls Church, Chantilly, Community, Dunn
      Loring, Belleview, Burke, Centreville, Alexandria, Annandale, Baileys
      Crossroads, Clifton, Herndon, and Vienna.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from VA, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Washington D.C.</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected. <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Washington DC Dept of Corrections
    </p>
    <p>
      Corrections records of persons who have been convicted of felonies and/or
      gross misdemeanors and sentenced to serve time in the DC correctional
      facility from 1991 - 2002. Includes records of persons who have been
      paroled or released. Records on approximately 23,000 persons. Results may
      include name, DOB, race, sex, charge, sentence, sentence date, case
      number, release date. Records are not updated.
      <br />
    </p>
    <p className="coverage-content-sub-title">Washington DC Sex Offender</p>
    <p>
      Registry contains data on nearly 300 Class A registered sex offenders.
      Class A sex offenders have been convicted of, or found not guilty by
      reason of insanity of abusive, violent, and/or forcable sexual offenses.
      Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from DC, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Washington</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">
      Washington AOC - District/Municipal Court
    </p>
    <p>
      District/Municipal Court records contain information on more than 1.8
      million individuals. Data may contain name, dob, offense, statute, case
      number, offense date, file date, plea, disposition date, and disposition.
      Updated quarterly.
      <br />
      Washington AOC - Superior Court Superior Court records contain information
      on more than 200,000 individuals. Data may contain name, dob, offense,
      statute, case number, offense date, file date, plea, resolution date, and
      resolution. Updated quarterly.
      <br />
    </p>
    <p className="coverage-content-sub-title">Washington Dept of Corrections</p>
    <p>
      Contains current and historical statewide felony and misdemeanor
      information for inmates, probationers and parolees who are or have been
      under the supervision of the Washington Department of Corrections since
      1995. The jurisdiction provides updates of the most current data available
      on a monthly basis.
      <br />
    </p>
    <p className="coverage-content-sub-title">Washington Sex Offender</p>
    <p>
      Contains information on nearly 1000 Level II and III Registered Sex
      Offenders. Data includes name, partial address, offense, statute and
      county.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from WA, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">West Virginia</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">West Virginia Sex Offender</p>
    <p>
      Registry contains information on over 1700 individuals. Data can include
      name, DOB, offense, victim information, conviction year, county
      information and city information. Photos included.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from WV, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Wisconsin</p>
    <p className="long-line">
      <br />
    </p>
    <p className="coverage-content-red">
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected.
      <br />
    </p>
    <p className="coverage-content-sub-title">Wisconsin Courts</p>
    <p>
      Statewide Court records of felony and misdemeanor cases disposed since
      1992. Records on approximately 158,000 persons. Results include case no.,
      name, DOB, charge(s), county of offense, disposition, disposition date,
      sentence date.
      <br />
    </p>
    <p className="coverage-content-sub-title">Wisconsin Dept of Corrections</p>
    <p>
      Records of statewide felony convictions on persons who have been sentenced
      to serve time at a state facility and/or released on parole since 1970.
      Records on approximately 50,000 persons. Results may include the county,
      case #, defendant name, DOB, race, sex, offense, sentence, sentence date,
      release date. The state has put updates of this file on HOLD. The file is
      current thru October 2002.
      <br />
    </p>
    <p className="coverage-content-sub-title">Wisconsin Sex Offender</p>
    <p>
      Sex Offender Registry generally contains information, including photos, on
      those individuals who were convicted of, incarcerated, or on supervision
      for a sex offense on or after December 25, 1993.Updated Monthly.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from WI, which contained records.
    </p>
    <p>
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="coverage-title">Wyoming</p>
    <p className="long-line">
      <br />
    </p>
    <p>
      The search you have selected is a search of the data sources listed in the
      description and may not represent 100% coverage of all the criminal
      records in the jurisdiction and or sources you have selected. <br />
      <br />
    </p>
    <p className="coverage-content-sub-title">Wyoming Sex Offender</p>
    <p>
      Wyoming Sex Offender Registry contains data on individuals determined to
      have a high risk of re-offending. Data may contain name, DOB, address,
      offense conviction place, and conviction place. Photos included.
      <br />
    </p>
    <p className="coverage-content-sub-title">P.R.I.O.R.S.</p>
    <p>
      Public Record Indexes of Record Searches. This database is comprised of
      proprietary criminal data compiled from previously ordered county,
      statewide and federal criminal requests, from WY, which contained records.
      <br />
    </p>
    <p className={"coverage-inner-para"}>
      <br />
    </p>
    <p className="long-line">
      <br />
    </p>
    <p className={"instant-criminal-footer"}>
      LP_Instant Criminal Coverage_02 19 2013
    </p>
  </div>
);

export default instantCriminalContent;



// WEBPACK FOOTER //
// ./src/components/coveragearea/InstantCriminal.js